
import { useEffect, useRef, useState, } from "react"
import axios from "../../../axiosInstance.js";
import { Alert } from '@mui/material';
import ContactPageIcon from '@mui/icons-material/ContactPage';
import ContactsIcon from '@mui/icons-material/Contacts';
import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined';
import ScaleOutlinedIcon from '@mui/icons-material/ScaleOutlined';
import WrapTextOutlinedIcon from '@mui/icons-material/WrapTextOutlined';
import InsertDriveFileOutlinedIcon from '@mui/icons-material/InsertDriveFileOutlined';
import FitbitIcon from '@mui/icons-material/Fitbit';
import AddModeratorOutlinedIcon from '@mui/icons-material/AddModeratorOutlined';
import DocumentScannerOutlinedIcon from '@mui/icons-material/DocumentScannerOutlined';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import EngineeringIcon from '@mui/icons-material/Engineering';
import FactoryIcon from '@mui/icons-material/Factory';
import DriveEtaIcon from '@mui/icons-material/DriveEta';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import BuildIcon from '@mui/icons-material/Build';
import AdjustIcon from '@mui/icons-material/Adjust';
import BottomNavigationBar from "../../../Component/Customers/BottomNavigationBar";
// "../../environment";
import EmailIcon from '@mui/icons-material/Email';
import AddBoxIcon from '@mui/icons-material/AddBox';
import { useNavigate, Link } from "react-router-dom";
import BottomNavigationVendor from "../../../Component/Vendors/BottomNavigationVendor/BottomNavigationVendor";
import icon2 from "../../../Assets/vehicle/icon2.svg";
import icon3 from "../../../Assets/vehicle/icon3.svg";
import leftArrow from "../../../Assets/navbar/left-arrow.png";
import icon4 from "../../../Assets/vehicle/icon4.svg";
import AppRegistrationIcon from '@mui/icons-material/AppRegistration';
import signupImage from '../../../Assets/login/signup.webp'
import rightarrow from '../../../Assets/navbar/right-arrow.svg'

import { motion, AnimatePresence } from "framer-motion";
import item1 from '../../../Assets/login/item1.svg';
import logo from '../../../Assets/navbar/logo.svg';

// /assets/navbar/right-arrow.svg
import {
    ShieldCheck, UserCheck, FileText, Truck, Box, Calendar, Shield, File, X, User
} from "lucide-react";
import rightArrow from '../../../Assets/navbar/right-arrow.svg';


import React from "react";
import { Fragment } from "react";
import { use } from "react";
import Navbar from "../../../Component/Home/Navbar";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import InsurerSelect from "../../../Component/Customers/InsurerSelect";
import { useModal } from "../../../context/ModalContext";
import { getISTDate } from "../../../utils/utils";

import { XMLParser } from 'fast-xml-parser';



const config = {
    cUrl: 'https://api.countrystatecity.in/v1/countries/IN',
    ckey: 'NHhvOEcyWk50N2Vna3VFTE00bFp3MjFKR0ZEOUhkZlg4RTk1MlJlaA=='
};

const validDriverNumber = (value) => {
    const regex = /^[6-9]\d{9}$/;
    if (!regex.test(value)) {
        return 'Mobile no should be right';
    }
    return '';
};

const validateEmail = (value) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!regex.test(value)) {
        return 'Invalid email address.';
    }
    return '';
};

export default function AddNewVehicle() {
    const { openModal, modalData, closeModal } = useModal();

    const [activeStep, setActiveStep] = useState(1);
    const [isLoadingStates, setIsLoadingStates] = useState(false);
    const [isLoadingCities, setIsLoadingCities] = useState(false);
    const [showConfirmModal, setShowConfirmModal] = useState(false);

    const [states, setStates] = useState([]);
    const [cities, setCities] = useState([]);

    const steps = [
        { id: 1, label: "Vehicle Details", icon: 'https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/vehicle/icon2.svg', activeIcon: 'https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/vehicle/icon2.svg' },
        { id: 2, label: "Representative Details", icon: 'https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/vehicle/icon3.svg', activeIcon: 'https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/vehicle/icon3.svg' }
    ];

    const [fileName, setFileName] = useState("");

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            setFileName(file.name);
        }
    };

    const stepRef = useRef(null);

    const prevStep = () => {

        stepRef.current?.scrollIntoView({ behavior: "smooth" });

        if (activeStep > 1) {
            setActiveStep((prev) => prev - 1);
        }
    };

    const [detailsApi, setDetailsApi] = useState(false)
    const [current, setCurrent] = useState('vehicle')

    const token = localStorage.getItem("token");
    const userId = localStorage.getItem("userId");
    const [alertInfo, setAlertInfo] = useState({ show: false, message: '', severity: 'info' });
    const navigate = useNavigate()

    const [apiData, setApiData] = useState({

    })

    const vehicleRegistrationDocRef = useRef(null);
    const insuranceDocRef = useRef(null);
    const fitnessCertificateRef = useRef(null);
    const pollutionCertificateDocRef = useRef(null);
    const operatorLicenseCopyRef = useRef(null);

    const [insurer, setInsurer] = useState("");

    // This function will capture the selected insurer
    const handleInsurerChange = (selectedInsurer) => {
        setInsurer(selectedInsurer);
        console.log("Selected Insurer: ", selectedInsurer);

        // setFormData((prev)=> {...prev, InsuranceName: selectedInsurer})

        setFormData((prev) => ({
            ...prev,
            InsuranceName: selectedInsurer,
        }));

        console.log(formData);
    };

    const [errors, setErrors] = useState({
        vehicleNo: '',
        driverName: '',
        driverNumber: '',
        driverEmail: '',
        craneType: '',
        craneCapacity: '',
        insuranceNo: '',
        insuranceExp: '',
        fitnessNo: '',
        fitnessExp: '',
        pollutionNo: '',
        pollutionExp: '',
        pollutionCertificateDoc: '',
        fitnessCertificate: '',
        insuranceDoc: '',
        vehicleRegistrationDoc: '',
        operatorLicenseCopy: ''
    });

    const validateField = (name, value) => {
        switch (name) {
            case 'vehicleNo':
                if (!value) return 'Vehicle number is required.';
                return '';
            case 'driverName':
                return value ? '' : 'Driver name is required.';
            case 'driverNumber':
                if (!value) return 'Driver number is required.';
                return '';
            case 'driverEmail':
                if (!value) return 'Driver email is required.';
                return '';
            case 'craneType':
                if (!value) return 'Crane Type is required.';
                return '';
            case 'craneCapacity':
                if (!value) return 'crane capacity is required.';
                return '';
            case 'insuranceNo':
                if (!value) return 'Insurance Number is required.';
                return '';
            case 'insuranceExp':
                if (!value) return 'Insurance Expiry is required.';
                return '';
            case 'fitnessNo':
                if (!value) return 'Fitness Number is required.';
                return '';
            case 'fitnessExp':
                if (!value) return 'Fitness Expiry is required.';
                return '';
            case 'pollutionNo':
                if (!value) return 'Pollution Number is required.';
                return '';
            case 'pollutionExp':
                if (!value) return 'Pollution Expiry is required.';
                return '';
            case 'pollutionCertificateDoc':
                if (!value) return 'Document is required..';
                return '';
            case 'fitnessCertificate':
                if (!value) return 'Document is required.';
                return '';
            case 'insuranceDoc':
                if (!value) return 'Document is required.';
                return '';
            case 'vehicleRegistrationDoc':
                if (!value) return 'Registration Document is required.';
                return '';
            case 'operatorLicenseCopy':
                if (!value) return 'Document is required.';
                return '';
            default:
                return '';
        }
    };
    const validateCustomerField = (name, value) => {
        switch (name) {
            case 'vehicleNo':
                if (!value) return 'Vehicle number is required.';
                return '';
            case 'driverName':
                return value ? '' : 'Representative name is required.';
            case 'driverNumber':
                if (!value) return 'Representative number is required.';
                return '';
            // case 'driverEmail':
            //     if (!value) return 'Representative email is required.';
            //     return '';
            default:
                return '';
        }
    };

    const [formData, setFormData] = useState({
        vehicleNo: '',
        ownerName: '',
        ownerAddress: '',
        ownerGST: '',
        ownerEmail: '',
        state: '',
        city: '',
        pincode: '',
        driverName: "",
        driverNumber: "",
        driverEmail: "",
        craneType: '',
        craneCapacity: '',
        fitnessNo: '',
        fitnessExp: '',
        pollutionNo: '',
        pollutionExp: '',
        pollutionCertificateDoc: '',
        fitnessCertificate: '',
        insuranceDoc: '',
        vehicleRegistrationDoc: '',
        operatorLicenseCopy: '',
        chassisNo: "",
        engineNo: "",
        make: "",
        model: "",
        year: '',
        GVW: '',
        InsuranceName: "",
        InsuranceValidUpto: "",

        additionalData: {
            Vehicle_rc_body_type_desc: "",
            Vehicle_rc_regn_no: "",
            Vehicle_rc_owner_name: "",
            Vehicle_state_cd: "",
            Vehicle_rc_permanent_address: "",
            Vehicle_rc_chasi_no: "",
            Vehicle_rc_eng_no: "",
            Vehicle_rc_maker_desc: "",
            Vehicle_rc_maker_model: "",
            Vehicle_rc_fit_upto: "",
            Vehicle_rc_tax_upto: "",
            Vehicle_rc_financer: "",
            Vehicle_rc_insurance_comp: "",
            Vehicle_rc_insurance_policy_no: "",
            Vehicle_rc_insurance_upto: "",
            Vehicle_rc_unld_wt: 0,
            Vehicle_rc_gvw: 0,
            Vehicle_rc_pucc_upto: "",
            Vehicle_rc_pucc_no: "",
            Vehicle_rc_status: "",
            Vehicle_rc_permit_no: "",
            Vehicle_rc_permit_issue_dt: "",
            Vehicle_rc_permit_valid_upto: ""
        }

    });

    // console.log('formdata', formData)

    const loadStates = () => {
        setIsLoadingStates(true);
        axios.get("/states", {
            baseURL: config.cUrl, // override baseURL if needed
            headers: {
                "X-CSCAPI-KEY": config.ckey,
            },
        }).then((response) => {
            setStates(response.data); // axios automatically parses JSON
            setIsLoadingStates(false);
        }).catch((error) => {
            console.error("Error loading states:", error);
            setIsLoadingStates(false);
        });
    }

    const loadCities = (stateCode) => {
        setIsLoadingCities(true);
        axios.get(`/states/${stateCode}/cities`, {
            baseURL: config.cUrl,
            headers: {
                "X-CSCAPI-KEY": config.ckey,
            },
        }).then((response) => {
            setCities(response.data); // axios parses JSON automatically
            setIsLoadingCities(false);
        }).catch((error) => {
            console.error("Error loading cities:", error);
            setIsLoadingCities(false);
        });
    };

    const [isEditMode, setIsEditMode] = useState(false)

    // Handle input change
    const handleChange = async (e) => {
        let { name, value, files, type } = e.target;

        // console.log('name', name)
        // console.log('value', value)
        // Handle file input separately

        if (type === 'file') {

            if (files[0] && files[0].size > 2097152) {
                setAlertInfo({ show: true, message: "File size should be less than 2 MB!", severity: 'error' });

                const refs = {
                    vehicleRegistrationDoc: vehicleRegistrationDocRef,
                    insuranceDoc: insuranceDocRef,
                    fitnessCertificate: fitnessCertificateRef,
                    pollutionCertificateDoc: pollutionCertificateDocRef,
                    operatorLicenseCopy: operatorLicenseCopyRef
                };

                if (refs[name] && refs[name].current) {
                    refs[name].current.value = "";
                }

                setFormData(prevState => ({
                    ...prevState,
                    [name]: null
                }));
                return;
            }


            setFormData(prevState => ({
                ...prevState,
                [name]: files[0]
            }));

            return;
        }

        else if (name === 'vehicleNo') {
            value = value.toUpperCase();

            clearFetchedValue();
            const vehicleNoRegex = /^([A-Z]{2}[\s-]?[0-9]{1,2}[\s-]?[A-Z]{1,3}[\s-]?[0-9]{4}|[0-9]{2}[\s-]?BH[\s-]?[0-9]{4}[\s-]?[A-Z]{2})$/i;

            if (vehicleNoRegex.test(value.trim())) {
                setVehicleNoError(null);
                setErrorInputName(null);
                fetchVehicleDetails(value.trim().toUpperCase(), openModal);
            } else {
                setVehicleNoError(true);
                setErrorInputName('vehicleNo');
            }


            if (value.trim() === '') {
                setVehicleNoError(null);
                setErrorInputName(null);
            }
        }

        else if (name === 'ownerName') {
            value = toTitleCase(value)

            if (/^[A-Za-z][A-Za-z\s.]{1,48}[A-Za-z.]?$/.test(value.trim()) || value.trim() === '') {
                setErrorInputName(null);
            } else {
                setErrorInputName('ownerName');
            }
        }
        else if (name === 'ownerAddress') {
            value = toTitleCase(value)

            if (/^[A-Za-z0-9\s,./#\-]{5,100}$/.test(value.trim()) || value.trim() === '') {
                setErrorInputName(null);
            } else {
                setErrorInputName('ownerAddress');
            }
        }

        else if (name === 'ownerEmail') {
            value = value.toLowerCase()
        }
        else if (name === 'ownerGST') {
            value = value.toUpperCase()
        }
        else if (name === 'ownerPAN') {
            // value = value.toUpperCase()
        }
        else if (name === 'pincode') {
            if (/^[1-9][0-9]{5}$/.test(value) || value.trim() === '') {
                setErrorInputName(null)
                handlePincodeChange(e)

            } else {
                setErrorInputName('pincode')
            }
        }
        else if (name === 'driverName') {
            value = toTitleCase(value)
        }

        else if (name === 'driverEmail') {
            value = value.toLowerCase()
        }

        // Always update form data
        setFormData((prevState) => ({
            ...prevState,
            [name]: value,
        }));


        setIsEditMode(true)
        setShowDetails(false);
        closeModal()
    };

    const toTitleCase = (input) => {
        return input
            .split(" ")
            .map(word =>
                word ? word[0].toUpperCase() + word.slice(1).toLowerCase() : ""
            )
            .join(" ");
    };




    const vehicleNoRef = useRef(null)
    const ownerNameRef = useRef(null)
    const ownerAddressRef = useRef(null)

    const ownerGSTRef = useRef(null)
    const ownerPANRef = useRef(null)
    const ownerEmailRef = useRef(null)


    const stateRef = useRef(null)
    const cityRef = useRef(null)
    const pincodeRef = useRef(null)
    const driverNameRef = useRef(null)
    const driverNumberRef = useRef(null)
    const driverEmailRef = useRef(null)
    const btnNextStepRef = useRef(null)
    const btnSubmitRef = useRef(null)

    const [errorInputName, setErrorInputName] = useState(null)
    const [vehicleNoError, setVehicleNoError] = useState(null)

    const nextStep = () => {

        if (formData.vehicleNo === undefined || formData.vehicleNo.trim().length < 3) {
            // showErrorToast('Vehicle number is mandatory')
            setVehicleNoError(true)
            setErrorInputName('vehicleNo')
            openModal({
                title: 'Error',
                body: 'Vehicle number is mandatory',
                iconType: 'error',
                autoClose: true,
            });
            return
        }

        const vehicleNoRegex = /^([A-Z]{2}[\s-]?[0-9]{1,2}[\s-]?[A-Z]{1,3}[\s-]?[0-9]{4}|[0-9]{2}[\s-]?BH[\s-]?[0-9]{4}[\s-]?[A-Z]{2})$/i;

        if (!vehicleNoRegex.test(formData.vehicleNo.trim())) {
            setVehicleNoError(true)
            setErrorInputName('vehicleNo')
            openModal({
                title: 'Error',
                body: 'Vehicle number format is incorrect',
                iconType: 'error',
                autoClose: true,
            });
            return
        }

        if (formData.ownerName === undefined || formData.ownerName.trim() === "") {
            setErrorInputName('ownerName');
            openModal({
                title: 'Error',
                body: 'Owner name is mandatory',
                iconType: 'error',
                autoClose: true,
            });
            return;
        }
        else if (!/^[A-Za-z][A-Za-z\s.]{1,48}[A-Za-z.]?$/.test(formData.ownerName.trim())) {
            setErrorInputName('ownerName');
            openModal({
                title: 'Error',
                body: 'Invalid owner name format',
                iconType: 'error',
                autoClose: true,
            });
            return;
        }

        if (formData.ownerAddress === undefined || formData.ownerAddress.trim() === "") {
            setErrorInputName('ownerAddress');
            openModal({
                title: 'Error',
                body: 'Owner address is mandatory',
                iconType: 'error',
                autoClose: true,
            });
            return;
        }
        else if (!/^[A-Za-z0-9\s,./#\-]{5,100}$/.test(formData.ownerAddress.trim())) {
            setErrorInputName('ownerAddress');
            openModal({
                title: 'Error',
                body: 'Invalid owner address format',
                iconType: 'error',
                autoClose: true,
            });
            return;
        }

        // ownerEmail is mandatory
        if (formData.ownerEmail === undefined || formData.ownerEmail.trim() === "") {
            setErrorInputName('ownerEmail');
            openModal({
                title: 'Error',
                body: 'Owner Email is mandatory',
                iconType: 'error',
                autoClose: true,
            });
            return;
        } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(formData.ownerEmail.trim())) {
            setErrorInputName('ownerEmail');
            openModal({
                title: 'Error',
                body: 'Invalid Owner Email format.',
                iconType: 'error',
                autoClose: true,
            });
            return;
        }

        // ownerGST is optional, skip validation if N/A or empty
        if (formData.ownerGST === undefined || formData.ownerGST.trim() === "") {
            // setErrorInputName('ownerGST');
            // openModal({
            //     title: 'Error',
            //     body: 'Owner GST is mandatory',
            //     iconType: 'error',
            //     autoClose: true,
            // });
            // return;
        } else if (formData.ownerGST.trim().toUpperCase() !== 'N/A' && !/^([0][1-9]|[1-2][0-9]|3[0-7])[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/.test(formData.ownerGST.trim())) {
            setErrorInputName('ownerGST');
            openModal({
                title: 'Error',
                body: 'Invalid Owner GST format',
                iconType: 'error',
                autoClose: true,
            });
            return;
        }

        // ownerPAN is mandatory
        // if (formData.ownerPAN === undefined || formData.ownerPAN.trim() === "") {

        //     setErrorInputName('ownerPAN');
        //     openModal({
        //         title: 'Error',
        //         body: 'Owner PAN is mandatory',
        //         iconType: 'error',
        //         autoClose: true,
        //     });
        //     return;
        // } else if (!/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(formData.ownerPAN.trim().toUpperCase())) {
        //     setErrorInputName('ownerPAN');
        //     openModal({
        //         title: 'Error',
        //         body: 'Invalid Owner PAN format.',
        //         iconType: 'error',
        //         autoClose: true,
        //     });
        //     return;
        // }


        if (formData.pincode === undefined || formData.pincode.trim() === "") {
            setErrorInputName('pincode');
            openModal({
                title: 'Error',
                body: 'Pincode is mandatory',
                iconType: 'error',
                autoClose: true,
            });
            return;
        }
        else if (!/^[1-9][0-9]{5}$/.test(formData.pincode.trim())) {
            setErrorInputName('pincode');
            openModal({
                title: 'Error',
                body: 'Invalid pincode format',
                iconType: 'error',
                autoClose: true,
            });
            return;
        }

        if (formData.city === undefined || formData.city.trim() === "") {
            setErrorInputName('city');
            openModal({
                title: 'Error',
                body: 'City is mandatory',
                iconType: 'error',
                autoClose: true,
            });
            return;
        }

        if (formData.state === undefined || formData.state.trim() === "") {
            setErrorInputName('state');
            openModal({
                title: 'Error',
                body: 'State is mandatory',
                iconType: 'error',
                autoClose: true,
            });
            return;
        }

        // All validations passed, proceed to next step
        setActiveStep(2);
        localStorage.removeItem('getPrefilledDetailsOfCustomer')
        console.log(formData);
        return;
    };

    useEffect(() => {

        if (errorInputName === 'vehicleNo') {
            if (modalData.isOpen) {
                vehicleNoRef.current.focus();
                setVehicleNoError(true)
            } else {
                setTimeout(() => {
                    vehicleNoRef.current?.focus();
                    setVehicleNoError(true)
                }, 10);
            }
        }

        if (errorInputName === 'ownerName') {
            if (modalData.isOpen) {
                ownerNameRef.current.focus();
                // setVehicleNoError(true)
            } else {
                setTimeout(() => {
                    ownerNameRef.current?.focus();
                    // setVehicleNoError(true)
                }, 10);
            }
        }

        if (errorInputName === 'ownerAddress') {
            if (modalData.isOpen) {
                ownerAddressRef.current.focus();
            } else {
                setTimeout(() => {
                    ownerAddressRef.current?.focus();
                }, 10);
            }
        }

        if (errorInputName === 'ownerEmail') {
            if (modalData.isOpen) {
                ownerEmailRef.current.focus();
            } else {
                setTimeout(() => {
                    ownerEmailRef.current?.focus();
                }, 10);
            }
        }

        if (errorInputName === 'ownerGST') {
            if (modalData.isOpen) {
                ownerGSTRef.current.focus();
            } else {
                setTimeout(() => {
                    ownerGSTRef.current?.focus();
                }, 10);
            }
        }

        if (errorInputName === 'ownerPAN') {
            if (modalData.isOpen) {
                ownerPANRef.current.focus();
            } else {
                setTimeout(() => {
                    ownerPANRef.current?.focus();
                }, 10);
            }
        }


        if (errorInputName === 'state') {
            if (modalData.isOpen) {
                stateRef.current.focus();
            } else {
                setTimeout(() => {
                    stepRef.current?.focus();
                }, 10);
            }
        }

        if (errorInputName === 'city') {
            if (modalData.isOpen) {
                cityRef.current.focus();
            } else {
                setTimeout(() => {
                    cityRef.current?.focus();
                }, 10);
            }
        }

        if (errorInputName === 'pincode') {
            if (modalData.isOpen) {
                pincodeRef.current.focus();
            } else {
                setTimeout(() => {
                    pincodeRef.current?.focus();
                }, 10);
            }
        }

        if (errorInputName === 'driverName') {
            if (modalData.isOpen) {
                driverNameRef.current.focus();
            } else {
                setTimeout(() => {
                    driverNameRef.current?.focus();
                }, 10);
            }
        }

        if (errorInputName === 'driverNumber') {
            if (modalData.isOpen) {
                driverNumberRef.current.focus();
            } else {
                setTimeout(() => {
                    driverNumberRef.current?.focus();
                }, 10);
            }
        }

        // if (errorInputName === 'driverEmail') {
        //     if (modalData.isOpen) {
        //         driverEmailRef.current.focus();
        //     } else {
        //         setTimeout(() => {
        //             driverEmailRef.current?.focus();
        //         }, 10);
        //     }
        // }




    }, [modalData.isOpen]);


    const showSuccessToast = (e) => {
        toast.success(e);
    };

    const showErrorToast = (e) => {
        toast.error(e);
    };

    const handleSubmit = async (e) => {
        console.log('handleSubmit calling: ');

        e.preventDefault();

        // if (!isEditMode) {
        //     userId.startsWith('VC-') ? navigate('/crane-all-vehicles') : navigate('/addVehicles', { state: { regNo: formData.vehicleNo, onSpotName: formData.driverName, onSpotContact: formData.driverNumber } });
        //     return
        // }

        if (formData.driverName === undefined || formData.driverName.trim() === "") {
            setErrorInputName('driverName');
            openModal({
                title: 'Error',
                body: 'Representative name is mandatory',
                iconType: 'error',
                autoClose: true,
            });
            return;
        }
        else if (!/^[A-Za-z][A-Za-z\s.]{1,48}[A-Za-z.]?$/.test(formData.driverName.trim())) {
            setErrorInputName('driverName');
            openModal({
                title: 'Error',
                body: 'Invalid Representative Name format',
                iconType: 'error',
                autoClose: true,
            });
            return;
        }

        if (formData.driverNumber === undefined || formData.driverNumber.trim() === "") {
            setErrorInputName('driverNumber');
            openModal({
                title: 'Error',
                body: 'Driver number is mandatory',
                iconType: 'error',
                autoClose: true,
            });
            return;
        }
        else if (!/^[6-9]\d{9}$/.test(formData.driverNumber.trim())) {
            setErrorInputName('driverNumber');
            openModal({
                title: 'Error',
                body: 'Enter valid 10 digit mobile number',
                iconType: 'error',
                autoClose: true,
            });
            return;
        }

        // if (formData.driverEmail === undefined || formData.driverEmail.trim() === "") {
        //     // setErrorInputName('driverEmail');
        //     // openModal({
        //     //     title: 'Error',
        //     //     body: 'Driver email is mandatory',
        //     //     iconType: 'error',
        //     //     autoClose: true,
        //     // });
        //     // return;
        // }
        // else if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(formData.driverEmail.trim())) {
        //     setErrorInputName('driverEmail');
        //     openModal({
        //         title: 'Error',
        //         body: 'Invalid Representative Email format.',
        //         iconType: 'error',
        //         autoClose: true,
        //     });
        //     return;
        // }

        // if (formData.driverEmail === undefined || formData.driverEmail.trim() === "") {
        //     setErrorInputName('driverEmail');
        //     openModal({
        //         title: 'Error',
        //         body: 'Driver email is mandatory',
        //         iconType: 'error',
        //         autoClose: true,
        //     });
        //     return;
        // }
        // else if (!/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(formData.driverEmail.trim())) {
        //     setErrorInputName('driverEmail');
        //     openModal({
        //         title: 'Error',
        //         body: 'Invalid driver email format',
        //         iconType: 'error',
        //         autoClose: true,
        //     });
        //     return;
        // }

        console.log('submitting form...');
        console.log(formData);
        console.log(formAdditionalData)

        // return

        setIsLoading(true)

        // return

        const newErrors = {};

        if (userId.startsWith('VC-')) {
            Object.keys(formData).forEach((field) => {
                newErrors[field] = validateField(field, formData[field]);
            });
        }
        if (userId.startsWith('CC-')) {
            Object.keys(formData).forEach((field) => {
                newErrors[field] = validateCustomerField(field, formData[field]);
            });
        }

        setErrors(newErrors);

        // if (Object.values(newErrors).some((error) => error)) {
        //     console.log('Validation errors:', newErrors);
        //     return;
        // }

        let path = userId.startsWith('VC-') ? 'addNewVehicleVendor' : 'addNewVehicle';

        const formDataObj = new FormData();
        for (const key in formData) {
            if (formData[key] !== undefined && formData[key] !== null && formData[key] !== "") {
                formDataObj.append(key, formData[key]);
            }
        }

        // formDataObj.append("additionalData", JSON.stringify(formAdditionalData));
        formDataObj.append("additionalData", JSON.stringify("{}"));

        // Debugging: Check FormData values
        for (let pair of formDataObj.entries()) {
            console.log(`${pair[0]}:`, pair[1]);
        }

        // console.log(formData);

        console.log(`${process.env.REACT_APP_BACKEND_URL}/api/${path}/${userId}`)

        localStorage.removeItem('getPrefilledDetailsOfCustomer')

        // return

        try {

            let response = await axios.post(
                `${process.env.REACT_APP_BACKEND_URL}/api/${path}/${userId}`,
                formDataObj,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        // **DO NOT** manually set Content-Type when using FormData
                    },
                }
            );

            console.log('Response: ', response.data);

            if (response.data.message === 'New vehicle added successfully' || response.data.message === "Vehicle info updated" || response.data.message === "New vehicle added") {

                localStorage.removeItem('currentStep')
                localStorage.removeItem('pickupLoc')
                localStorage.removeItem('dropLoc')
                localStorage.removeItem('latitude')
                localStorage.removeItem('longitude')
                localStorage.setItem('formData', JSON.stringify(formData))
                // openModal({
                //     title: 'Success',
                //     body: response.data.message,
                //     iconType: 'success',
                //     autoClose: true,
                // });
                userId.startsWith('VC-') ? navigate('/crane-all-vehicles') : navigate('/addVehicles', { state: { regNo: formData.vehicleNo, onSpotName: formData.driverName, onSpotContact: formData.driverNumber } });
            }
            else if (response.data.message === "Vehicle Already Registered As Yours !" || response.data.message === "Already Registered") {

                openModal({
                    title: 'Error',
                    body: response.data.message,
                    iconType: 'error',
                    autoClose: true,
                });
            }

        } catch (error) {
            console.error('Error submitting data:', error);
            openModal({
                title: 'Error',
                body: error?.response?.data?.errors[0] ? error?.response?.data?.errors[0] : error?.response.data.message,
                iconType: 'error',
                autoClose: true,
            });
        }
        finally {
            setIsLoading(false)
        }
    };

    useEffect(() => {
        if (formData.vehicleNo != "" &&
            formData.driverName != "" &&
            formData.driverNumber != "") {
            setDetailsApi(true)
        }
    },
        [formData.vehicleNo,
        formData.driverName,
        formData.driverNumber])

    useEffect(() => {
        if (userId) {
            loadStates();
        }
    }, [userId])





    const handleKeyDown = (event) => {
        if (event.key === "Enter") {

            let form = {
                vehicleNo: formData.vehicleNo,
                driverName: "",
                driverNumber: "",
                driverEmail: "",
                craneType: '',
                craneCapacity: '',
                insuranceNo: '',
                insuranceExp: '',
                fitnessNo: '',
                fitnessExp: '',
                pollutionNo: '',
                pollutionExp: '',
                pollutionCertificateDoc: '',
                fitnessCertificate: '',
                insuranceDoc: '',
                vehicleRegistrationDoc: '',
                operatorLicenseCopy: '',
                chassisNo: "CH109245ED6789",
                engineNo: "EN09876VH5432",
                make: "Tata",
                model: "LPT 1613",
                year: 2023,
                type: "Truck",
                application: "Logistics",
                GVW: 16200,
                ULW: 6000,
                InsuranceName: "ICICI Lombard",
            }
            setFormData(form)
        }
    };

    const handleStepClick = (e) => {
        setActiveStep(e);
    };

    const [isModalOpen, setIsModalOpen] = useState(false)
    const [isModalSubmit, setIsModalSubmit] = useState(false)

    const handleContinue = async (e) => {

        setFormData((prevState) => ({
            ...prevState,
            InsuranceName: e,
        }));

        setIsModalOpen(false)

        setActiveStep(2)

    }

    const [isLoading, setIsLoading] = useState(false);

    const handleDriverNameChange = (e) => {
        const { name, value } = e.target;

        if (name === 'driverName') {
            if (/^[A-Za-z][A-Za-z\s.]{1,48}[A-Za-z.]?$/.test(value.trim()) || value.trim() === '') {
                setErrorInputName(null);
            } else {
                setErrorInputName('driverName');
            }
        }



        setFormData((prevState) => ({
            ...prevState,
            [name]: toTitleCase(value),
        }));

        closeModal()

    }

    const handleDriverEmailChange = (e) => {
        const { name, value } = e.target;

        if (name === 'driverEmail') {
            if (/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(value) || value.trim() === '') {
                setErrorInputName(null)
            } else {
                setErrorInputName('driverEmail')
            }
        }

        setFormData((prevState) => ({
            ...prevState,
            [name]: value.toLowerCase(),
        }));

        closeModal()

    }

    const handleDriverMobileChange = (e) => {
        const { name, value } = e.target;
        if (value && value.length > 10) {
            return
        }
        if (name === 'driverNumber') {
            if (/^[6-9]\d{9}$/.test(value) || value.trim() === '') {
                setErrorInputName(null)
            } else {
                setErrorInputName('driverNumber')
            }
        }

        setFormData((prevState) => ({
            ...prevState,
            [name]: value,
        }));

        closeModal()

    }
    const [showDetails, setShowDetails] = useState(false);
    const [apiVehicleDetails, setApiVehicleDetails] = useState({});

    const handleVehicleSearch = async (vehicleNumber) => {

        try {
            setIsLoading(true)

            // alert(vehicleNumber)
            let response = await fetchVehicleDetails(vehicleNumber)

            console.log(response)
            openModal({
                title: 'Error',
                body: 'Unable to fetch vehicle details...',
                iconType: 'error',
                autoClose: false,
            });
            return


        } catch (error) {
            console.log(error)
            openModal({
                title: 'Error',
                body: 'Unablefdfdf to fetch vehicle details...',
                iconType: 'error',
                autoClose: false,
            });
        }
        finally {
            setIsLoading(false)
        }

        return

        setTimeout(() => {
            setIsLoading(false)
            setShowDetails(!showDetails); // show animation
        }, 2000);
    };

    const [phoneError, setPhoneError] = useState(null);

    const arrowRef = useRef(null);

    const response = {
        success: true,
        data: {
            "Vehicle_stautsMessage": "OK",
            "Vehicle_rc_regn_no": "HR46E8144",
            "Vehicle_rc_regn_dt": "08-Oct-2018",
            "Vehicle_rc_regn_upto": "15-Jul-2022",
            "Vehicle_rc_purchase_dt": "16-Apr-2018",
            "Vehicle_rc_owner_sr": "1",
            "Vehicle_rc_owner_name": "S******R K****R",
            "Vehicle_state_cd": "HR",
            "Vehicle_rto_cd": "46",
            "Vehicle_api_response_message": "No response received from AITP API.",
            "Vehicle_rc_present_address": "Rohtak, 124001",
            "Vehicle_rc_permanent_address": "Rohtak, 124001",
            "Vehicle_rc_vch_catg": "LGV",
            "Vehicle_rc_vh_class_desc": "Goods Carrier(LGV)",
            "Vehicle_rc_chasi_no": "MAT505410H0K*****",
            "Vehicle_rc_eng_no": "3.8SGI72KSY8*****",
            "Vehicle_rc_maker_desc": "TATA MOTORS LTD",
            "Vehicle_rc_maker_model": "TATA SFC 407 CNG / 31 BS-IV",
            "Vehicle_rc_body_type_desc": "RECOVERY VAN",
            "Vehicle_rc_fuel_desc": "CNG ONLY",
            "Vehicle_rc_color": "NA",
            "Vehicle_rc_norms_desc": "BHARAT STAGE IV",
            "Vehicle_rc_fit_upto": "15-Jul-2022",
            "Vehicle_rc_np_upto": "07-Oct-2020",
            "Vehicle_rc_np_issued_by": "Secretary, RTA Rohtak",
            "Vehicle_rc_tax_upto": "31-08-2022",
            "Vehicle_rc_financer": "INDIA INFOLINE FINANCE LTD",
            "Vehicle_rc_insurance_comp": "National Insurance Co. Ltd.",
            "Vehicle_rc_insurance_policy_no": "42060031216360002229",
            "Vehicle_rc_insurance_upto": "04-Jan-2023",
            "Vehicle_rc_manu_month_yr": "10/2017",
            "Vehicle_rc_unld_wt": "2430",
            "Vehicle_rc_gvw": "5550",
            "Vehicle_rc_no_cyl": "4",
            "Vehicle_rc_cubic_cap": "3783.00",
            "Vehicle_rc_seat_cap": "3",
            "Vehicle_rc_sleeper_cap": "0",
            "Vehicle_rc_stand_cap": "0",
            "Vehicle_rc_wheelbase": "3100",
            "Vehicle_rc_registered_at": "RTA, ROHTAK, Haryana",
            "Vehicle_rc_status_as_on": "06-May-2025",
            "Vehicle_rc_pucc_upto": "19-Aug-2022",
            "Vehicle_rc_pucc_no": "HR04600220002561",
            "Vehicle_rc_status": "Fitness Expired",
            "Vehicle_rc_ncrb_status": null,
            "Vehicle_rc_blacklist_status": null,
            "Vehicle_rc_permit_no": "HR/46/NP/LGV/2018/28",
            "Vehicle_rc_permit_issue_dt": "08-Oct-2018",
            "Vehicle_rc_permit_valid_from": "08-Oct-2018",
            "Vehicle_rc_permit_valid_upto": "07-Oct-2023",
            "Vehicle_rc_permit_type": "National Permit [LIGHT GOODS VEHICLE]",
            "Vehicle_rc_permit_code": "106",
            "Vehicle_rc_noc_details": null,
            "Vehicle_rc_vh_type": "T",
            "Vehicle_rc_vh_class": "59",
            "Vehicle_rc_noc_dt": null,
            "Vehicle_rc_fuel_cd": "6",
            "Vehicle_rc_maker_cd": "86",
            "Vehicle_rc_model_cd": "55320831000R",
            "Vehicle_rc_norms_cd": "0",
            "Vehicle_rc_sale_amt": "1020823.0",
            "Vehicle_rc_own_catg_desc": "OTHERS",
            "Vehicle_rc_vch_catg_desc": "LIGHT GOODS VEHICLE",
            "Vehicle_rc_owner_cd_desc": "INDIVIDUAL",
            "Vehicle_rc_vehicle_surrendered_to_dealer": "0",
            "Vehicle_rc_owner_history_offName": null,
            "Vehicle_rc_owner_history_owner_name": null,
            "Vehicle_rc_owner_history_owner_sr": "0",
            "Vehicle_rc_owner_history_stateCd": null,
            "Vehicle_rc_currentadd_districtcode": "0",
            "Vehicle_rc_non_use": "false",
            "Vehicle_rc_passenger_tax": null,
            "Vehicle_rc_goods_tax": null,
            "Vehicle_rc_no_of_axle": "2",
            "Vehicle_rc_qr_url": null,
            "Vehicle_rc_auth_name": null,
            "Vehicle_rc_auth_sign": null,
            "Vehicle_rc_approval_date": null,
            "Vehicle_rc_hp": null,
            "Vehicle_rc_mandal_desc": null,
            "Vehicle_rc_taluk_cd": null,
            "Vehicle_rc_permit_catg": "105",
            "Vehicle_rc_tax_mode": "M",
            "Vehicle_rc_permit_issuing_authority": "RTA, ROHTAK",
            "Vehicle_rc_width": null,
            "Vehicle_rc_fitness_result": null
        }
    };

    const [formAdditionalData, setFormAdditionalData] = useState(null)

    useEffect(() => {

        return

        // const vehicleNoRegex = /^[a-zA-Z]{2}[0-9]{1,2}[a-zA-Z]{1,3}[0-9]{4}$/;
        const vehicleNoRegex = /^[A-Z]{2}[0-9]{2}[A-Z]{1,3}[0-9]{4}$/;

        if (!vehicleNoRegex.test(formData.vehicleNo.toUpperCase())) {
            clearForm();
            setFormAdditionalData({});
            setShowArrow(false);
            return
        }

        try {

            // { vh_number: "HR46E8144" },

            setIsLoading(true)
            setShowArrow(false);

            console.log("Response:", response.data);

            if (response.data && response.data.Vehicle_stautsMessage === 'OK') {

                console.log("RC Verified:", response.data);

                setVehicleNoError(false)
                setErrorInputName(null)

                let ins = response.data.Vehicle_rc_insurance_comp.split(' ')[0].toLowerCase()

                const insurers = [
                    "NA", "ACKO GENERAL INSURANCE", "DHFL GIC", "ZUNO GENERAL INSURANCE",
                    "NATIONAL INSURANCE", "ORIENTAL INSURANCE", "UNIVERSAL SOMPO", "MAGMA HDI",
                    "ROYAL SUNDRAM", "LIBERTY GIC", "SHRIRAM GIC", "CHOLA MS", "NIVA BUPA",
                    "CARE HEALTH", "ZURICH KOTAK GIC", "FUTURE GENERALI", "RELIANCE GIC",
                    "GO DIGIT GIC", "SBI GENERAL INSURANCE", "NEW INDIA ASSURANCE",
                    "UNITED INDIA INSURANCE", "IFFCO TOKIO", "ICICI LOMBARD", "TATA AIG",
                    "HDFC ERGO", "BAJAJ ALLIANZ"
                ].sort();

                const matchedInsurer = insurers.find(company =>
                    company.toLowerCase().startsWith(ins)
                );

                // setShowArrow(true);

                setFormData((prevState) => ({
                    ...prevState,
                    engineNo: response.data.Vehicle_rc_eng_no,
                    chassisNo: response.data.Vehicle_rc_chasi_no,
                    make: response.data.Vehicle_rc_maker_desc,
                    model: response.data.Vehicle_rc_maker_model,
                    year: response.data.Vehicle_rc_manu_month_yr?.split('/')[1],
                    GVW: response.data.Vehicle_rc_gvw,
                    // InsuranceName: response.data.Vehicle_rc_insurance_comp,
                    InsuranceName: matchedInsurer,
                    InsuranceValidUpto: response.data.Vehicle_rc_insurance_upto,
                    // ownerName: response.data.Vehicle_rc_owner_name,
                    // ownerAddress: response.data.Vehicle_rc_present_address,
                    state: response.data.Vehicle_state_cd,
                    city: response.data.Vehicle_rc_present_address?.split(',')[0].trim(),
                    pincode: response.data.Vehicle_rc_present_address?.split(',')[1]?.trim(),
                }));

                setFormAdditionalData({
                    Vehicle_rc_body_type_desc: response.data.Vehicle_rc_body_type_desc,
                    Vehicle_rc_regn_no: response.data.Vehicle_rc_regn_no,
                    Vehicle_rc_owner_name: response.data.Vehicle_rc_owner_name,
                    Vehicle_rc_permanent_address: response.data.Vehicle_rc_permanent_address,
                    Vehicle_rc_chasi_no: response.data.Vehicle_rc_chasi_no,
                    Vehicle_rc_eng_no: response.data.Vehicle_rc_eng_no,
                    Vehicle_rc_maker_desc: response.data.Vehicle_rc_maker_desc,
                    Vehicle_rc_maker_model: response.data.Vehicle_rc_maker_model,
                    Vehicle_rc_fit_upto: response.data.Vehicle_rc_fit_upto,
                    Vehicle_rc_tax_upto: response.data.Vehicle_rc_tax_upto,
                    Vehicle_rc_financer: response.data.Vehicle_rc_financer,
                    Vehicle_rc_insurance_comp: response.data.Vehicle_rc_insurance_comp,
                    Vehicle_rc_insurance_policy_no: response.data.Vehicle_rc_insurance_policy_no,
                    Vehicle_rc_insurance_upto: response.data.Vehicle_rc_insurance_upto,
                    Vehicle_rc_unld_wt: response.data.Vehicle_rc_unld_wt,
                    Vehicle_rc_gvw: response.data.Vehicle_rc_gvw,
                    Vehicle_rc_pucc_upto: response.data.Vehicle_rc_pucc_upto,
                    Vehicle_rc_pucc_no: response.data.Vehicle_rc_pucc_no,
                    Vehicle_rc_status: response.data.Vehicle_rc_status,
                    Vehicle_rc_permit_no: response.data.Vehicle_rc_permit_no,
                    Vehicle_rc_permit_issue_dt: response.data.Vehicle_rc_permit_issue_dt,
                    Vehicle_rc_permit_valid_upto: response.data.Vehicle_rc_permit_valid_upto,
                })

                loadCities(response.data.Vehicle_state_cd);


                arrowRef.current?.click();

            } else {
                console.warn("Verification failed or returned false");
            }

        } catch (error) {
            console.log("Error:", error.response?.data || error.message || error);
            // console.log(error.response?.data.status)

            // if (error.response?.data.status) {
            //     showErrorToast(error.response?.data.status)
            // }
            // clearForm();
            // setFormAdditionalData({});
            // setShowArrow(false);
        }
        finally {
            setIsLoading(false)
        }

    }, [formData.vehicleNo]);

    const verifyRC = async () => {
        console.log('Fetching vehicle details: ')

        try {

            // { vh_number: "HR46E8144" },

            setIsLoading(true)

            const response = await axios.post(
                "https://dashboard.traqo.in/api/v1/kyc/verify_rc/",
                { vh_number: formData.vehicleNo },
                {
                    auth: {
                        username: "9312408268",
                        password: "9312408268@123",
                    },
                    headers: {
                        "Content-Type": "application/json"
                    }
                }
            );

            console.log("Response:", response.data);

            if (response.data && response.data.data.Vehicle_msg === "No data found") {
                showErrorToast('No vehicle data found')
                return
            }

            if (response.data && response.data.data.Vehicle_stautsMessage === 'OK') {
                console.log("RC Verified:", response.data.data);

                showSuccessToast('Vehicle details fetched successfully')

                setShowArrow(true);

                setFormData((prevState) => ({
                    ...prevState,
                    engineNo: response.data.Vehicle_rc_eng_no,
                    chassisNo: response.data.Vehicle_rc_chasi_no,
                    make: response.data.Vehicle_rc_maker_desc,
                    model: response.data.Vehicle_rc_maker_model,
                    year: response.data.Vehicle_rc_manu_month_yr?.split('/')[1],
                    GVW: response.data.Vehicle_rc_gvw,
                    InsuranceName: response.data.Vehicle_rc_insurance_comp,
                    InsuranceValidUpto: response.data.Vehicle_rc_insurance_upto,
                    ownerName: response.data.Vehicle_rc_owner_name,
                    ownerAddress: response.data.Vehicle_rc_present_address,
                    state: response.data.Vehicle_state_cd,
                    city: response.data.Vehicle_rc_present_address?.split(',')[0].trim(),
                    pincode: response.data.Vehicle_rc_present_address?.split(',')[1]?.trim(),
                }));

                // setFormAdditionalData({
                //     Vehicle_rc_body_type_desc: response.data.Vehicle_rc_body_type_desc,
                //     Vehicle_rc_regn_no: response.data.Vehicle_rc_regn_no,
                //     Vehicle_rc_owner_name: response.data.Vehicle_rc_owner_name,
                //     Vehicle_rc_permanent_address: response.data.Vehicle_rc_permanent_address,
                //     Vehicle_rc_chasi_no: response.data.Vehicle_rc_chasi_no,
                //     Vehicle_rc_eng_no: response.data.Vehicle_rc_eng_no,
                //     Vehicle_rc_maker_desc: response.data.Vehicle_rc_maker_desc,
                //     Vehicle_rc_maker_model: response.data.Vehicle_rc_maker_model,
                //     Vehicle_rc_fit_upto: response.data.Vehicle_rc_fit_upto,
                //     Vehicle_rc_tax_upto: response.data.Vehicle_rc_tax_upto,
                //     Vehicle_rc_financer: response.data.Vehicle_rc_financer,
                //     Vehicle_rc_insurance_comp: response.data.Vehicle_rc_insurance_comp,
                //     Vehicle_rc_insurance_policy_no: response.data.Vehicle_rc_insurance_policy_no,
                //     Vehicle_rc_insurance_upto: response.data.Vehicle_rc_insurance_upto,
                //     Vehicle_rc_unld_wt: response.data.Vehicle_rc_unld_wt,
                //     Vehicle_rc_gvw: response.data.Vehicle_rc_gvw,
                //     Vehicle_rc_pucc_upto: response.data.Vehicle_rc_pucc_upto,
                //     Vehicle_rc_pucc_no: response.data.Vehicle_rc_pucc_no,
                //     Vehicle_rc_status: response.data.Vehicle_rc_status,
                //     Vehicle_rc_permit_no: response.data.Vehicle_rc_permit_no,
                //     Vehicle_rc_permit_issue_dt: response.data.Vehicle_rc_permit_issue_dt,
                //     Vehicle_rc_permit_valid_upto: response.data.Vehicle_rc_permit_valid_upto,
                // })

                // loadCities(response.data.Vehicle_state_cd);

                // arrowRef.current?.click();

            } else {
                console.warn("Verification failed or returned false");
            }

        } catch (error) {
            console.error("Error:", error.response?.data || error.message);
            console.log(error.response?.data.status)

            if (error.response?.data.status) {
                showErrorToast(error.response?.data.status)
            }
            clearForm();
            setFormAdditionalData({});
            setShowArrow(false);
        }
        finally {
            setIsLoading(false)
        }
    };

    const clearForm = () => {
        setFormData({
            vehicleNo: formData.vehicleNo,
            ownerName: '',
            ownerAddress: '',
            state: '',
            city: '',
            pincode: '',
            driverName: '',
            driverNumber: '',
            driverEmail: '',
            craneType: '',
            craneCapacity: '',
            fitnessNo: '',
            fitnessExp: '',
            pollutionNo: '',
            pollutionExp: '',
            pollutionCertificateDoc: '',
            fitnessCertificate: '',
            insuranceDoc: '',
            vehicleRegistrationDoc: '',
            operatorLicenseCopy: '',
            chassisNo: '',
            engineNo: '',
            make: '',
            model: '',
            year: '',
            GVW: '',
            InsuranceName: '',
            InsuranceValidUpto: ''
        });


    };

    const [showArrow, setShowArrow] = useState(true);

    useEffect(() => {
        // To load data from local storage if it is available
        const fd = JSON.parse(localStorage.getItem('formData') || '{}');
        // console.log(fd);

        if (fd && Object.keys(fd).length > 0) {
            setFormData(prev => ({
                ...prev,
                ...fd
            }));
        }
    }, []);

    useEffect(() => {

        const handleKeyDown = (e) => {

            // const activeElement = document.activeElement;
            // console.log("Key pressed:", e.key);
            // console.log("Active element:", activeElement);

            if (e.key === 'Escape' || e.key === ' ' || e.key === 'Enter') {

                setShowDetails(false);
                // vehicleNoRef.current.focus()              

            }

        };

        document.addEventListener('keydown', handleKeyDown);

        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [setShowDetails, isModalOpen,]);

    const showDetailsModalCloseRef = useState(null)


    const [pincode, setPincode] = useState('');
    const [locationData, setLocationData] = useState(null);
    const [error, setError] = useState('');

    const handlePincodeChange = async (e) => {

        const value = e.target.value;

        if (value.length === 6) {

            try {

                setIsLoading(true)

                try {
                    const response = await mockPincodeAPI(value);
                    console.log(response)

                    if (response.status) {

                        setFormData((prev) => ({
                            ...prev,
                            state: response.data.data[0].stateName,
                            city: response.data.data[0].districtName,
                        }));
                    }
                }
                catch (error) {
                    openModal({
                        title: 'Error',
                        body: 'Pincode not found. ',
                        iconType: 'error',
                        autoClose: true,
                    });
                }

            } catch (error) {
                openModal({
                    title: 'Error',
                    body: 'Error occurred when fetching pincode.',
                    iconType: 'error',
                    autoClose: true,
                });
            }
            finally {
                setIsLoading(false)
            }
        }
    };

    const mockPincodeAPI = async (pincode) => {

        // const response = await axios.get(`http://localhost:4001/api/getDistrictAndState/${pincode}`);
        const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/getDistrictAndState/${pincode}`);

        // const response = await axios.get(`https://onboard.claimpro.in/api/api/getDistrictAndState/${pincode}`);

        return response;
    };

    useEffect(() => {
        const fetchAndPrefill = async () => {
            try {

                const userRole = localStorage.getItem('userRole');
                if (userRole !== 'customer') {
                    return;
                }

                // const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/getPrefilledDetailsOfCustomer/${userId}`);
                // const result = await res.json();

                const response = await axios.get(`/api/getPrefilledDetailsOfCustomer/${userId}`,
                    {
                        baseURL: process.env.REACT_APP_BACKEND_URL,
                    }
                );
                const result = response.data; // axios auto-parses JSON

                console.log('Fetched Data:', result);

                if (result?.data) {
                    setFormData(prev => ({
                        ...prev,
                        ownerName: result?.data.CustomerName || '',
                        ownerAddress: result?.data.address || '',
                        ownerEmail: result?.data.email || '',
                        pincode: result?.data.pincode || '',
                        city: result?.data.district || '',
                        state: result?.data.state || '',
                        ownerGST: (result?.data.GSTNo && result?.data.GSTNo !== 'No GST No') ? result?.data.GSTNo : ''
                    }));
                } else {
                    console.warn('No data returned from API');
                    return;
                }

            } catch (err) {
                console.error('Failed to fetch address:', err);
            }
        };

        fetchAndPrefill();
    }, []);

    const fetchVehicleDetails = async (vehicleNumber, openModal) => {
        try {

            // alert(matchInsurer("Cholamandalam MS General Insurance Co. Ltd.")); 
            // alert(matchInsurer("HDFC ERGO General Insurance Company Ltd")); 
            // alert(matchInsurer("The New India Assurance Company Limited")); 
            // alert(matchInsurer("Reliance General Insurance Co. Ltd.")); 
            // alert(matchInsurer("Tata AIG General Insurance Co. Ltd.")); 
            // alert(matchInsurer("Bajaj Allianz General Insurance Co. Ltd.")); 
            // alert(matchInsurer("GoDigit General Insurance Ltd.")); 
            // alert(matchInsurer("United India Insurance Co. Ltd.")); 
            // alert(matchInsurer("National Insurance Co. Ltd.")); 
            // alert(matchInsurer("Future Generali General Insurance  Co. Ltd.")); 
            // alert(matchInsurer("Shriram General Insurance  Co. Ltd.")); 
            // alert(matchInsurer("Liberty General Insurance Limited")); 
            // alert(matchInsurer("SBI General"));            
            // return

            setIsLoading(true);

            const response = await axios.post(
                "/api/fetchVehicleDetails",
                 JSON.stringify({ vehiclenumber: vehicleNumber }),
                {
                    baseURL: process.env.REACT_APP_BACKEND_URL,
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            );

            if (response.status !== 200) {
                openModal({
                    title: 'Error',
                    body: 'Server error. Please try again later.',
                    iconType: 'error',
                    autoClose: false,
                });
                return;
            }

            const data = response.data;

            console.log('Vehicle Data:', data);

            if (!data || data.success !== true) {
                openModal({
                    title: 'Error',
                    body: 'Unable to fetch vehicle details...',
                    iconType: 'error',
                    autoClose: false,
                });
                return;
            }

            if (!data.data || Object.keys(data.data).length === 0) {
                openModal({
                    title: 'Error',
                    body: 'No vehicle details found for the given number.',
                    iconType: 'error',
                    autoClose: false,
                });
                return;
            }

            const vehicleDetails = data?.data?.VehicleDetails || {};
            
            // Store API vehicle details for later use
            setApiVehicleDetails(vehicleDetails);

            setFormData((prevState) => ({
                ...prevState,
                engineNo: vehicleDetails.rc_eng_no || '',
                chassisNo: vehicleDetails.rc_chasi_no || '',
                make: vehicleDetails.rc_maker_desc || '',
                model: vehicleDetails.rc_maker_model || '',
                year: vehicleDetails.rc_manu_month_yr?.split?.('/')?.[1] || '',
                GVW: vehicleDetails.rc_gvw || '',
                InsuranceName: vehicleDetails.rc_insurance_comp || '',
                InsuranceValidUpto: vehicleDetails.rc_insurance_upto || '',
            }));

            setFormAdditionalData({
                Vehicle_rc_body_type_desc: vehicleDetails.rc_body_type_desc || '',
                Vehicle_rc_regn_no: vehicleDetails.rc_regn_no || '',
                Vehicle_rc_owner_name: formData?.ownerName || '',
                Vehicle_state_cd : vehicleDetails.state_cd || '',
                Vehicle_rc_permanent_address: vehicleDetails.rc_permanent_address || '',
                Vehicle_rc_chasi_no: vehicleDetails.rc_chasi_no || '',
                Vehicle_rc_eng_no: vehicleDetails.rc_eng_no || '',
                Vehicle_rc_maker_desc: vehicleDetails.rc_maker_desc || '',
                Vehicle_rc_maker_model: vehicleDetails.rc_maker_model || '',
                Vehicle_rc_fit_upto: vehicleDetails.rc_fit_upto || '',
                Vehicle_rc_tax_upto: vehicleDetails.rc_tax_upto || '',
                Vehicle_rc_financer: vehicleDetails.rc_financer || '',
                Vehicle_rc_insurance_comp: vehicleDetails.rc_insurance_comp || '',
                Vehicle_rc_insurance_policy_no: vehicleDetails.rc_insurance_policy_no || '',
                Vehicle_rc_insurance_upto: vehicleDetails.rc_insurance_upto || '',
                Vehicle_rc_unld_wt: vehicleDetails.rc_unld_wt || 0,
                Vehicle_rc_gvw: vehicleDetails.rc_gvw || 0,
                Vehicle_rc_status: vehicleDetails.rc_status || '',
            });

            console.log('original insurer: ')
            console.log(data?.data?.VehicleDetails?.rc_insurance_comp)
            console.log('matched Insurer')
            console.log(matchInsurer(data?.data?.VehicleDetails?.rc_insurance_comp))

            setTimeout(() => {
                setIsLoading(false);
                setShowDetails(!showDetails);
            }, 200);

        } catch (error) {
            console.error('❌ Error fetching vehicle data:', error.message);
            openModal({
                title: 'Error',
                body: 'Something went wrong while fetching vehicle data.',
                iconType: 'error',
                autoClose: false,
            });
        } finally {
            setIsLoading(false);
        }
    };

    const normalize = (str) => str.toLowerCase().replace(/[^a-z]/g, ''); // remove spaces, dots, etc.

    const insurerAliases = {
        "chola ms": ["cholamandalammsgeneralinsurancecoltd"],
        "hdfc ergo": ["hdfcerogeneralinsurancecompanyltd"],
        "new india assurance": ["thenewindiaassurancecompanylimited"],
        "reliance gic": ["reliancegeneralinsurancecoltd"],
        "tata aig": ["tataaiggeneralinsurancecoltd"],
        "bajaj allianz": ["bajajallianzgeneralinsurancecoltd"],
        "go digit gic": ["godigitgeneralinsuranceltd"],
        "united india insurance": ["unitedindiainsurancecoltd"],
        "national insurance": ["nationalinsurancecoltd"],
        "future generali": ["futuregeneraligeneralinsurancecoltd"],
        "shriram gic": ["shriramgeneralinsurancecoltd"],
        "sbi general insurance": ["sbigeneralinsurance", "sbigeneral"],
    };

    // State code to state name mapping
    const stateCodeToName = {
        'AN': 'Andaman and Nicobar Islands',
        'AP': 'Andhra Pradesh',
        'AR': 'Arunachal Pradesh',
        'AS': 'Assam',
        'BR': 'Bihar',
        'CH': 'Chandigarh',
        'CT': 'Chhattisgarh',
        'DD': 'Daman and Diu',
        'DL': 'Delhi',
        'DN': 'Dadra and Nagar Haveli',
        'GA': 'Goa',
        'GJ': 'Gujarat',
        'HR': 'Haryana',
        'HP': 'Himachal Pradesh',
        'JK': 'Jammu and Kashmir',
        'JH': 'Jharkhand',
        'KA': 'Karnataka',
        'KL': 'Kerala',
        'LA': 'Ladakh',
        'LD': 'Lakshadweep',
        'MP': 'Madhya Pradesh',
        'MH': 'Maharashtra',
        'MN': 'Manipur',
        'ML': 'Meghalaya',
        'MZ': 'Mizoram',
        'NL': 'Nagaland',
        'OD': 'Odisha',
        'PY': 'Puducherry',
        'PB': 'Punjab',
        'RJ': 'Rajasthan',
        'SK': 'Sikkim',
        'TN': 'Tamil Nadu',
        'TG': 'Telangana',
        'TR': 'Tripura',
        'UP': 'Uttar Pradesh',
        'UT': 'Uttarakhand',
        'WB': 'West Bengal',
    };

    // Function to convert state code to state name
    const getStateNameFromCode = (stateCode) => {
        return stateCodeToName[stateCode?.toUpperCase()] || stateCode || '';
    };

    // Function to parse permanent address and extract city and pincode
    const parsePermanentAddress = (address) => {
        if (!address) return { city: '', pincode: '' };
        
        let city = '';
        let pincode = '';

        // Look for 6-digit pincode anywhere in the address
        const pincodeMatch = address.match(/\b(\d{6})\b/);
        
        if (pincodeMatch) {
            pincode = pincodeMatch[1];
            
            // Split by comma and find the part containing or before the pincode
            const parts = address.split(',').map(part => part.trim());
            
            // Find which part contains the pincode
            const pincodePartIndex = parts.findIndex(part => part.includes(pincode));
            
            if (pincodePartIndex > 0) {
                // City is the part immediately before the pincode part
                city = parts[pincodePartIndex - 1];
            } else if (pincodePartIndex === 0 && parts.length > 1) {
                // If pincode is in the first part, city might be second part
                city = parts[1];
            } else {
                // Fallback: take first part as city
                city = parts[0];
            }
        } else {
            // No pincode found, take first part as city
            const parts = address.split(',').map(part => part.trim());
            city = parts[0];
        }

        return { city, pincode };
    };

    function matchInsurer(insurerName) {
        const normalized = normalize(insurerName);

        // Exact alias match
        for (const [key, aliases] of Object.entries(insurerAliases)) {
            if (aliases.includes(normalized)) {
                return key.toUpperCase();
            }
        }

        // Partial fallback match
        const insurers = [
            "ACKO GENERAL INSURANCE", "DHFL GIC", "ZUNO GENERAL INSURANCE",
            "NATIONAL INSURANCE", "ORIENTAL INSURANCE", "UNIVERSAL SOMPO", "MAGMA HDI",
            "ROYAL SUNDRAM", "LIBERTY GIC", "SHRIRAM GIC", "CHOLA MS", "NIVA BUPA",
            "CARE HEALTH", "ZURICH KOTAK GIC", "FUTURE GENERALI", "RELIANCE GIC",
            "GO DIGIT GIC", "SBI GENERAL INSURANCE", "NEW INDIA ASSURANCE",
            "UNITED INDIA INSURANCE", "IFFCO TOKIO", "ICICI LOMBARD", "TATA AIG",
            "HDFC ERGO", "BAJAJ ALLIANZ"
        ];

        const matched = insurers.find((company) =>
            normalized.includes(normalize(company))
        );

        return matched || "OTHER";
    }

    const clearFetchedValue = () => {
        setFormData((prevState) => ({
            ...prevState,
            engineNo: '',
            chassisNo: '',
            make: '',
            model: '',
            year: '',
            GVW: '',
            InsuranceName: '',
            InsuranceValidUpto: '',

            // ownerName: '',
            // ownerAddress: '',
            // state: '',
            // city: '',
            // pincode: '',
        }));

        setFormAdditionalData({
            Vehicle_rc_body_type_desc: '',
            Vehicle_rc_regn_no: '',
            Vehicle_rc_owner_name: '',
            Vehicle_rc_permanent_address: '',
            Vehicle_rc_chasi_no: '',
            Vehicle_rc_eng_no: '',
            Vehicle_rc_maker_desc: '',
            Vehicle_rc_maker_model: '',
            Vehicle_rc_fit_upto: '',
            Vehicle_rc_tax_upto: '',
            Vehicle_rc_financer: '',
            Vehicle_rc_insurance_comp: '',
            Vehicle_rc_insurance_policy_no: '',
            Vehicle_rc_insurance_upto: '',
            Vehicle_rc_unld_wt: 0,
            Vehicle_rc_gvw: 0,

            // Vehicle_rc_pucc_upto: null,
            // Vehicle_rc_pucc_no: null,
            // Vehicle_rc_permit_no: null,
            // Vehicle_rc_permit_issue_dt: null,
            // Vehicle_rc_permit_valid_upto: null,

            Vehicle_rc_status: '',
        });

    }

    return (
        <>
            <div className='min-h-screen bg-white' ref={stepRef}>

                {/* <button className="btn btn-primary" onClick={() => { arrowRef.current?.click(); }}>Fetch API</button> */}

                {/* <Navbar/> */}
                <div className=" w-full rounded-[30px] bg-white pb-[70px] md:px-[56px] px-2 mx-auto">
                    <div className="fixed top-0 left-0 w-full flex items-center justify-between px-4 py-3 bg-white z-50">
                        <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/navbar/logo-navbar-compressed.png' alt="logo" className="h-[3rem] w-[3rem] object-contain" />
                        <Link to='/user-profile-details' className=' h-10 w-10 bg-white flex items-center justify-center rounded-full border shadow'>
                            <User className="text-gray-500" />
                        </Link>
                    </div>
                    {activeStep === 1 && (
                        <>
                            <div className="container-fluid ">

                                <div className="flex items-center justify-center md:flex-row flex-col-reverse  gap-[1%] md:pr-[2%] pr-0">
                                    <div className='max-w-[862px] md:block hidden w-full'>
                                        <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/login/signup.webp' alt="" />
                                    </div>
                                    <div className='max-w-[430px] w-full mt-[4rem]'>
                                        <div className="flex flex-col gap-[9.6vw] md:gap-[42px] mb-[2rem] ">
                                            <div className="flex items-center gap-2 pt-6 px-2">
                                                <AppRegistrationIcon className="text-[#21A6E9]" />
                                                <h6 className="text-[20px]  md:text-[28px] font-[500] font-satoshi text-[#000000]">
                                                    Give Vehicle Details
                                                </h6>
                                            </div>

                                            <div>
                                                <label htmlFor="" style={{ display: 'inline-block', }} className='font-[500] font-satoshi text-[13px] text-[#000000] mb-0 pb-[13px]'>Vehicle Registration No <span style={{ color: 'red', fontWeight: 'bolder', fontSize: "16px", }}>*</span></label>

                                                <div className={`flex items-center gap-[10px] pb-[9px] border-b-[2px] border-solid h-[40px] box-border ${vehicleNoError ? 'border-[#FF0000]' : 'border-[#000000]'
                                                    }`}
                                                >
                                                    <img src='https://www.svgrepo.com/show/341486/vehicle-tracking-vehicle-tracking-iot-transportation-internet-of-things-connected-vehicle.svg' alt="" className="w-[20px] h-[20px]" />
                                                    {/* <input
                                                        ref={vehicleNoRef}
                                                        type="text"
                                                        id="vehicleNo"
                                                        name="vehicleNo"
                                                        required
                                                        value={formData.vehicleNo}
                                                        onChange={handleChange}
                                                        style={{ textTransform: "uppercase" }}
                                                        className="font-[400] outline-none w-full font-satoshi text-[16px] text-[#515151] h-[24px] leading-[24px] p-0 m-0"
                                                        placeholder="Enter Vehicle Number"
                                                        onKeyDown={(e) => {
                                                            if (e.key === 'Enter') {

                                                                if (showDetails) {
                                                                    showDetailsModalCloseRef.current.click()
                                                                }
                                                                else {
                                                                    btnNextStepRef.current.click()
                                                                }

                                                                if (modalData.isOpen) {
                                                                    closeModal()
                                                                }
                                                            }
                                                        }}
                                                    /> */}

                                                    <input
                                                        ref={vehicleNoRef}
                                                        type="text"
                                                        id="vehicleNo"
                                                        name="vehicleNo"
                                                        required
                                                        value={formData.vehicleNo}
                                                        onChange={handleChange}
                                                        className="font-[400] outline-none w-full font-satoshi text-[16px] text-[#515151] h-[24px] leading-[24px] p-0 m-0"
                                                        placeholder="Enter Vehicle Number"
                                                        onKeyDown={(e) => {
                                                            if (e.key === 'Enter') {

                                                                if (showDetails) {
                                                                    showDetailsModalCloseRef.current.click()
                                                                }
                                                                else {
                                                                    btnNextStepRef.current.click()


                                                                }

                                                                if (modalData.isOpen) {
                                                                    closeModal()
                                                                }
                                                            }
                                                        }}
                                                    />


                                                    {/* <img 
                                                        ref={arrowRef}
                                                        src={rightArrow}
                                                        alt="arrow"
                                                        className="h-[40px] w-[40px] cursor-pointer rounded-full p-2 bg-[#21A6E9]"
                                                        onClick={() => {
                                                            // handleVehicleSearch()
                                                        }
                                                        }
                                                    /> */}



                                                </div>
                                                <label htmlFor="" className='mt-[8%] font-[500] font-satoshi text-[13px] text-[#000000] mb-0 pb-[13px]'
                                                    style={{ display: 'inline-block', }}>Owner Name <span style={{ color: 'red', fontWeight: 'bolder', fontSize: "16px", }}>*</span></label>

                                                <div
                                                    className={`flex items-center gap-[10px] pb-[9px] border-b-[2px] border-solid h-[40px] box-border ${errorInputName === 'ownerName' ? 'border-[#FF0000]' : 'border-[#000000]'
                                                        }`}>
                                                    <img src='https://www.svgrepo.com/show/483503/registration-pictogram-2.svg' alt="" className="w-[20px] h-[20px]" />
                                                    <input
                                                        ref={ownerNameRef}
                                                        type="text"
                                                        id="ownerName"
                                                        name="ownerName"
                                                        required
                                                        value={formData.ownerName}
                                                        onChange={handleChange}
                                                        className="font-[400] outline-none w-full font-satoshi text-[16px] text-[#515151] h-[24px] leading-[24px] p-0 m-0"
                                                        placeholder="Enter Owner Name"
                                                        onKeyDown={(e) => {
                                                            if (e.key === 'Enter') {

                                                                if (showDetails) {
                                                                    showDetailsModalCloseRef.current.click()
                                                                }
                                                                else {
                                                                    btnNextStepRef.current.click()
                                                                }

                                                                if (modalData.isOpen) {
                                                                    closeModal()
                                                                }
                                                            }
                                                        }}
                                                    />
                                                </div>
                                                {apiVehicleDetails?.rc_owner_name && (
                                                    <p className='font-satoshi text-[12px] text-[#999999] mt-1'>
                                                         <span className='font-[600] text-[#666666]'>{apiVehicleDetails.rc_owner_name}</span>
                                                    </p>
                                                )}

                                                {/* <label htmlFor="" className='mt-[10%] font-[500] font-satoshi text-[13px] text-[#000000] mb-0 pb-[13px]'>Owner Address</label> */}
                                                <label htmlFor="" className='mt-[8%] font-[500] font-satoshi text-[13px] text-[#000000] mb-0 pb-[13px]'
                                                    style={{ display: 'inline-block', }}>Owner Address <span style={{ color: 'red', fontWeight: 'bolder', fontSize: "16px", }}>*</span></label>


                                                <div className={`flex items-center gap-[10px] pb-[9px] border-b-[2px] border-solid h-[40px] box-border ${errorInputName === 'ownerAddress' ? 'border-[#FF0000]' : 'border-[#000000]'
                                                    }`}>
                                                    <img src='https://www.svgrepo.com/show/530593/address.svg' alt="" className="w-[20px] h-[20px]" />
                                                    <input
                                                        ref={ownerAddressRef}
                                                        type="text"
                                                        id="ownerAddress"
                                                        name="ownerAddress"
                                                        required
                                                        value={formData.ownerAddress}
                                                        onChange={handleChange}
                                                        className="font-[400] outline-none w-full font-satoshi text-[16px] text-[#515151] h-[24px] leading-[24px] p-0 m-0"
                                                        placeholder="Enter Owner Address"
                                                        onKeyDown={(e) => {
                                                            if (e.key === 'Enter') {

                                                                if (showDetails) {
                                                                    showDetailsModalCloseRef.current.click()
                                                                }
                                                                else {
                                                                    btnNextStepRef.current.click()
                                                                }

                                                                if (modalData.isOpen) {
                                                                    closeModal()
                                                                }
                                                            }
                                                        }}
                                                    />
                                                </div>

                                                <label htmlFor="" className='mt-[8%] font-[500] font-satoshi text-[13px] text-[#000000] mb-0 pb-[13px]'
                                                    style={{ display: 'inline-block', }}>Owner Email <span style={{ color: 'red', fontWeight: 'bolder', fontSize: "16px", }}>*</span></label>


                                                <div className={`flex items-center gap-[10px] pb-[9px] border-b-[2px] border-solid h-[40px] box-border ${errorInputName === 'ownerEmail' ? 'border-[#FF0000]' : 'border-[#000000]'
                                                    }`}>
                                                    <img src='https://www.svgrepo.com/show/530593/address.svg' alt="" className="w-[20px] h-[20px]" />
                                                    <input
                                                        ref={ownerEmailRef}
                                                        type="text"
                                                        id="ownerEmail"
                                                        name="ownerEmail"
                                                        required
                                                        value={formData.ownerEmail}
                                                        onChange={handleChange}
                                                        className="font-[400] outline-none w-full font-satoshi text-[16px] text-[#515151] h-[24px] leading-[24px] p-0 m-0"
                                                        placeholder="Enter Owner Email"
                                                        onKeyDown={(e) => {
                                                            if (e.key === 'Enter') {

                                                                if (showDetails) {
                                                                    showDetailsModalCloseRef.current.click()
                                                                }
                                                                else {
                                                                    btnNextStepRef.current.click()
                                                                }

                                                                if (modalData.isOpen) {
                                                                    closeModal()
                                                                }
                                                            }
                                                        }}
                                                    />
                                                </div>

                                                <label htmlFor="" className='mt-[8%] font-[500] font-satoshi text-[13px] text-[#000000] mb-0 pb-[13px]'
                                                    style={{ display: 'inline-block', }}>Pin Code <span style={{ color: 'red', fontWeight: 'bolder', fontSize: "16px", }}>*</span></label>

                                                <div className={`flex items-center gap-[10px] pb-[9px] border-b-[2px] border-solid h-[40px] box-border ${errorInputName === 'pincode' ? 'border-[#FF0000]' : 'border-[#000000]'
                                                    }`}>
                                                    <img src='https://www.svgrepo.com/show/530593/address.svg' alt="" className="w-[20px] h-[20px]" />
                                                    <input
                                                        ref={pincodeRef}
                                                        type="tel"                            // Triggers numeric keypad
                                                        inputMode="numeric"                  // Hints numeric input
                                                        pattern="[0-9]*"
                                                        id="pincode"
                                                        name="pincode"
                                                        required
                                                        value={formData.pincode}
                                                        onChange={handleChange}
                                                        className="font-[400] outline-none w-full font-satoshi text-[16px] text-[#515151] h-[24px] leading-[24px] p-0 m-0 "
                                                        placeholder="Enter Pin Code"
                                                        onKeyDown={(e) => {
                                                            if (e.key === 'Enter') {

                                                                if (showDetails) {
                                                                    showDetailsModalCloseRef.current.click()
                                                                }
                                                                else {
                                                                    btnNextStepRef.current.click()
                                                                }

                                                                if (modalData.isOpen) {
                                                                    closeModal()
                                                                }
                                                            }
                                                        }}
                                                    />
                                                </div>


                                                {/* <label htmlFor="" className='mt-[10%] font-[500] font-satoshi text-[13px] text-[#000000] mb-0 pb-[13px]'>City</label>\ */}
                                                <label htmlFor="" className='mt-[8%] font-[500] font-satoshi text-[13px] text-[#000000] mb-0 pb-[13px]'
                                                    style={{ display: 'inline-block', }}>City <span style={{ color: 'red', fontWeight: 'bolder', fontSize: "16px", }}>*</span></label>

                                                <div className={`flex items-center gap-[10px] pb-[9px] border-b-[2px] border-solid h-[40px] box-border ${errorInputName === 'city' ? 'border-[#FF0000]' : 'border-[#000000]'
                                                    }`}>
                                                    <img src='https://www.svgrepo.com/show/490638/city.svg' alt="" className="w-[20px] h-[20px]" />

                                                    <input
                                                        readOnly
                                                        ref={cityRef}
                                                        key={formData.city + new Date().getMilliseconds()}
                                                        name="city"
                                                        value={formData.city} // This should match city.iso2
                                                        className="font-[400] outline-none w-full font-satoshi text-[16px] text-[#515151] h-[24px] leading-[24px] p-0 m-0"
                                                        onChange={handleChange}
                                                        placeholder="Enter City"
                                                        onKeyDown={(e) => {
                                                            if (e.key === 'Enter') {

                                                                if (showDetails) {
                                                                    showDetailsModalCloseRef.current.click()
                                                                }
                                                                else {
                                                                    btnNextStepRef.current.click()
                                                                }

                                                                if (modalData.isOpen) {
                                                                    closeModal()
                                                                }
                                                            }
                                                        }}
                                                    />

                                                </div>

                                                <label htmlFor="" className='mt-[8%] font-[500] font-satoshi text-[13px] text-[#000000] mb-0 pb-[13px]'
                                                    style={{ display: 'inline-block', }}>State <span style={{ color: 'red', fontWeight: 'bolder', fontSize: "16px", }}>*</span></label>

                                                <div className={`flex items-center gap-[10px] pb-[9px] border-b-[2px] border-solid h-[40px] box-border ${errorInputName === 'state' ? 'border-[#FF0000]' : 'border-[#000000]'
                                                    }`}>
                                                    <img src='https://www.svgrepo.com/show/124113/state-or-country-administration-building.svg' alt="" className="w-[20px] h-[20px]" />
                                                    <input
                                                        readOnly
                                                        ref={stateRef}
                                                        name="state"
                                                        onChange={handleChange}
                                                        className="font-[400] outline-none w-full font-satoshi text-[16px] text-[#515151] h-[24px] leading-[24px] p-0 m-0"
                                                        value={formData.state}
                                                        placeholder="Enter State"

                                                        onKeyDown={(e) => {
                                                            if (e.key === 'Enter') {

                                                                if (showDetails) {
                                                                    showDetailsModalCloseRef.current.click()
                                                                }
                                                                else {
                                                                    btnNextStepRef.current.click()
                                                                }

                                                                if (modalData.isOpen) {
                                                                    closeModal()
                                                                }
                                                            }
                                                        }}
                                                    />

                                                </div>

                                                <label htmlFor="" className='mt-[8%] font-[500] font-satoshi text-[13px] text-[#000000] mb-0 pb-[13px]'
                                                    style={{ display: 'inline-block', }}> GSTIN <span style={{ color: 'red', fontWeight: 'bolder', fontSize: "16px", }}></span></label>


                                                <div className={`flex items-center gap-[10px] pb-[9px] border-b-[2px] border-solid h-[40px] box-border ${errorInputName === 'ownerGST' ? 'border-[#FF0000]' : 'border-[#000000]'
                                                    }`}>
                                                    <img src='https://www.svgrepo.com/show/530593/address.svg' alt="" className="w-[20px] h-[20px]" />
                                                    <input
                                                        ref={ownerGSTRef}
                                                        type="text"
                                                        id="ownerGST"
                                                        name="ownerGST"
                                                        required
                                                        value={formData.ownerGST}
                                                        onChange={handleChange}
                                                        className="font-[400] outline-none w-full font-satoshi text-[16px] text-[#515151] h-[24px] leading-[24px] p-0 m-0"
                                                        placeholder="Enter GST"
                                                        onKeyDown={(e) => {
                                                            if (e.key === 'Enter') {

                                                                if (showDetails) {
                                                                    showDetailsModalCloseRef.current.click()
                                                                }
                                                                else {
                                                                    btnNextStepRef.current.click()
                                                                }

                                                                if (modalData.isOpen) {
                                                                    closeModal()
                                                                }
                                                            }
                                                        }}
                                                    />
                                                </div>



                                                {phoneError && (
                                                    <div
                                                        style={{
                                                            color: "red",
                                                            marginTop: "5px",
                                                            marginLeft: "20px",
                                                        }}
                                                    >
                                                        {phoneError}

                                                    </div>
                                                )}

                                            </div>

                                        </div>


                                        <div className="flex justify-center fixed bottom-0 left-0 right-0 z-[10] md:relative md:bottom-auto md:left-auto md:right-auto">
                                            <div className="mobile-only-shadow flex items-center justify-between bg-white p-2 rounded-t-xl w-full max-w-[30rem] gap-[0.5rem] mx-auto md:rounded-none md:p-0 md:bg-transparent">
                                                <button
                                                    onClick={() => setShowConfirmModal(true)}
                                                    className="font-satoshi flex items-center justify-center gap-2 text-white text-base font-medium py-3 px-2 rounded-full transition-all w-full
                                                                                            bg-[#EE3840] hover:bg-[#d32f2f]"
                                                >
                                                    <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/navbar/right-arrow.svg' alt="Continue" className="h-[1rem] w-[1rem] rotate-180" />
                                                    Back
                                                </button>
                                                <button
                                                    ref={btnNextStepRef}
                                                    onClick={nextStep}
                                                    className="font-satoshi flex items-center justify-center gap-2
                                                    bg-[#21A6E9] hover:bg-[#1e94d6]  text-white text-base font-medium py-3 px-1 rounded-full transition-all w-full"
                                                >
                                                    Continue
                                                    <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/navbar/right-arrow.svg' alt="Back" className="h-[1rem] w-[1rem]" />
                                                </button>


                                            </div>
                                        </div>


                                    </div></div>

                                <AnimatePresence>
                                    {showDetails && (
                                        <motion.div
                                            initial={{ opacity: 0, y: 50 }}
                                            animate={{ opacity: 1, y: 0 }}
                                            exit={{ opacity: 0, y: 50 }}
                                            transition={{ duration: 0.4 }}
                                            className="fixed top-0 left-0 w-full h-full bg-black bg-opacity-50 z-50 flex justify-center items-center"
                                            onClick={() => setShowDetails(false)} // Close on outside click
                                        >
                                            <div
                                                className="relative w-[90%] max-w-3xl bg-white rounded-2xl shadow-xl p-6 overflow-y-auto max-h-[90vh]"
                                                onClick={(e) => e.stopPropagation()} // Prevent close on inside click
                                            >
                                                {/* Close Button */}
                                                <button
                                                    onClick={() => setShowDetails(false)}
                                                    className="absolute top-4 right-4 text-gray-500 hover:text-black transition"
                                                >
                                                    <X size={24} />
                                                </button>

                                                <h2 className="text-xl font-semibold mb-4 font-satoshi text-[#000]">Vehicle Details</h2>

                                                <button ref={showDetailsModalCloseRef} onClick={() => {
                                                    setShowDetails(false)
                                                }}></button>

                                                <div className="grid grid-cols-2 md:grid-cols-2 gap-4">
                                                    {/* Chassis No */}
                                                    <div>
                                                        <label className="font-satoshi font-[500] text-[16px] text-[#000] mb-1">
                                                            <span className="flex items-center gap-1">
                                                                <FileText size={16} />
                                                                Chassis No
                                                            </span>
                                                        </label>
                                                        <div className="flex items-center gap-2 border-b-2 border-black pb-1">
                                                            <input
                                                                readOnly
                                                                value={formData.chassisNo}
                                                                className="bg-transparent pl-5 w-full text-[#515151] outline-none font-satoshi"
                                                            />
                                                        </div>
                                                    </div>

                                                    {/* Engine No */}
                                                    <div>
                                                        <label className="font-satoshi font-[500] text-[16px] text-[#000] mb-1">
                                                            <span className="flex items-center gap-1">
                                                                <Truck size={16} />
                                                                Engine No
                                                            </span>
                                                        </label>
                                                        <div className="flex items-center gap-2 border-b-2 border-black pb-1">
                                                            <input
                                                                readOnly
                                                                value={formData.engineNo}
                                                                className="bg-transparent pl-5 w-full text-[#515151] outline-none font-satoshi"
                                                            />
                                                        </div>
                                                    </div>

                                                    {/* Make */}
                                                    <div>
                                                        <label className="font-satoshi font-[500] text-[16px] text-[#000] mb-1">
                                                            <span className="flex items-center gap-1">
                                                                <Box size={16} />
                                                                Make
                                                            </span>
                                                        </label>
                                                        <div className="flex items-center gap-2 border-b-2 border-black pb-1">
                                                            <input
                                                                readOnly
                                                                value={formData.make}
                                                                className="bg-transparent pl-5 w-full text-[#515151] outline-none font-satoshi"
                                                            />
                                                        </div>
                                                    </div>

                                                    {/* Model */}
                                                    <div>
                                                        <label className="font-satoshi font-[500] text-[16px] text-[#000] mb-1">
                                                            <span className="flex items-center gap-1">
                                                                <Box size={16} />
                                                                Model
                                                            </span>
                                                        </label>
                                                        <div className="flex items-center gap-2 border-b-2 border-black pb-1">
                                                            <input
                                                                readOnly
                                                                value={formData.model}
                                                                className="bg-transparent pl-5 w-full text-[#515151] outline-none font-satoshi"
                                                            />
                                                        </div>
                                                    </div>

                                                    {/* Year */}
                                                    <div>
                                                        <label className="font-satoshi font-[500] text-[16px] text-[#000] mb-1">
                                                            <span className="flex items-center gap-1">
                                                                <Calendar size={16} />
                                                                Year
                                                            </span>
                                                        </label>
                                                        <div className="flex items-center gap-2 border-b-2 border-black pb-1">
                                                            <input
                                                                readOnly
                                                                value={formData.year}
                                                                className="bg-transparent pl-5 w-full text-[#515151] outline-none font-satoshi"
                                                            />
                                                        </div>
                                                    </div>

                                                    {/* GVW */}
                                                    <div>
                                                        <label className="font-satoshi font-[500] text-[16px] text-[#000] mb-1">
                                                            <span className="flex items-center gap-1">
                                                                <Shield size={16} />
                                                                GVW
                                                            </span>
                                                        </label>
                                                        <div className="flex items-center gap-2 border-b-2 border-black pb-1">
                                                            <input
                                                                readOnly
                                                                value={formData.GVW}
                                                                className="bg-transparent pl-5 w-full text-[#515151] outline-none font-satoshi"
                                                            />
                                                        </div>
                                                    </div>

                                                    {/* Insurer Name */}
                                                    <div>
                                                        <label className="font-satoshi font-[500] text-[16px] text-[#000]">
                                                            <span className="flex items-center gap-1">
                                                                <FileText size={16} />
                                                                Insurer Name
                                                            </span>
                                                        </label>
                                                        <div className="flex items-center gap-2 border-b-2 border-black pb-1">
                                                            <input
                                                                readOnly
                                                                value={formData.InsuranceName}
                                                                className="bg-transparent pl-5 w-full text-[#515151] outline-none font-satoshi"
                                                            />
                                                        </div>
                                                    </div>

                                                    {/* Insurance Valid Upto */}
                                                    <div>
                                                        <label className="font-satoshi font-[500] text-[16px] text-[#000]">
                                                            <span className="flex items-center gap-1">
                                                                <Calendar size={16} className="inline-block mr-1" />
                                                                Insurance Valid Upto
                                                            </span>
                                                        </label>
                                                        <div className="flex items-center gap-2 border-b-2 border-black pb-1">
                                                            <input
                                                                readOnly
                                                                value={formData.InsuranceValidUpto}
                                                                className="bg-transparent pl-5 w-full text-[#515151] outline-none font-satoshi"
                                                            />
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* Action Buttons */}
                                                <div className="flex justify-between gap-4 mt-8">
                                                    <button
                                                        onClick={() => {
                                                            setFormData({
                                                                ...formData,
                                                                ownerName: '',
                                                                ownerAddress: '',
                                                                ownerEmail: '',
                                                                pincode: '',
                                                                city: '',
                                                                state: '',
                                                                ownerGST: '',
                                                            });
                                                            setShowDetails(false);
                                                        }}
                                                        className="px-8 py-2 text-sm rounded-md bg-[#EE3840] text-white hover:bg-[#d32f2f] font-satoshi font-medium"
                                                    >
                                                        Back
                                                    </button>
                                                    <button
                                                        onClick={() => {
                                                            // Parse address to extract city and pincode
                                                            const { city: parsedCity, pincode: parsedPincode } = parsePermanentAddress(apiVehicleDetails?.rc_permanent_address);
                                                            
                                                            // Fill form fields with API data
                                                            setFormData((prevState) => ({
                                                                ...prevState,
                                                                ownerName: '', // Keep empty as API returns masked data
                                                                ownerAddress: apiVehicleDetails?.rc_permanent_address || '',
                                                                ownerEmail: apiVehicleDetails?.rc_owner_email || '',
                                                                pincode: parsedPincode || apiVehicleDetails?.rc_pincode || '',
                                                                city: parsedCity || apiVehicleDetails?.rc_city || '',
                                                                state: getStateNameFromCode(apiVehicleDetails?.state_cd) || '',
                                                            }));
                                                            setShowDetails(false);
                                                        }}
                                                        className="px-6 py-2 text-sm rounded-md bg-[#21A6E9] text-white hover:bg-[#1e94d6] font-satoshi font-medium"
                                                    >
                                                        Continue
                                                    </button>
                                                </div>
                                            </div>
                                        </motion.div>
                                    )}
                                </AnimatePresence>

                                <AnimatePresence>
                                    {showConfirmModal && (
                                        <motion.div
                                            initial={{ opacity: 0, y: 50 }}
                                            animate={{ opacity: 1, y: 0 }}
                                            exit={{ opacity: 0, y: 50 }}
                                            transition={{ duration: 0.4 }}
                                            className="font-satoshi fixed top-0 left-0 w-full h-full bg-black bg-opacity-50 z-50 flex justify-center items-center"
                                            onClick={() => setShowConfirmModal(false)} // Close on outside click
                                        >
                                            <motion.div
                                                initial={{ scale: 0.8 }}
                                                animate={{ scale: 1 }}
                                                exit={{ scale: 0.8 }}
                                                transition={{ duration: 0.3 }}
                                                className="bg-white rounded-xl p-6 max-w-md w-[90%] shadow-lg"
                                                onClick={(e) => e.stopPropagation()} // Prevent closing when clicking inside
                                            >
                                                <h2 className="text-lg font-bold text-gray-800 mb-2">Are you sure?</h2>
                                                <p className="text-sm text-gray-600 mb-4">All entered data will be lost if you go back. Do you want to continue?</p>

                                                <div className="flex justify-end gap-4">
                                                    <button
                                                        onClick={() => setShowConfirmModal(false)}
                                                        className="px-4 py-2 text-sm rounded-md border border-gray-300 text-gray-700 hover:bg-gray-100"
                                                    >
                                                        Stay
                                                    </button>
                                                    <button
                                                        onClick={() => {
                                                            const keepKeys = [
                                                                "iconify-version",
                                                                "iconify-count",
                                                                "token",
                                                                "userId",
                                                                "loginId",
                                                                "loginTime",
                                                                "userRole",
                                                                "fromLogin",
                                                                "justLoggedIn",
                                                                "gps_location",
                                                                "currentService"
                                                            ];
                                                            Object.keys(localStorage).forEach((key) => {
                                                                if (!keepKeys.includes(key)) {
                                                                    localStorage.removeItem(key);
                                                                }
                                                            });
                                                            sessionStorage.clear();
                                                            navigate('/customer-home-page')                                                          
                                                        }}
                                                        className="px-4 py-2 text-sm rounded-md bg-[#EE3840] text-white hover:bg-[#d32f2f]"
                                                    >
                                                        Go Back
                                                    </button>
                                                </div>
                                            </motion.div>
                                        </motion.div>
                                    )}
                                </AnimatePresence>


                            </div>
                        </>
                    )}

                    {activeStep === 2 && (
                        <>
                            <div className="container-fluid  ">
                                <div className="flex items-center justify-center md:flex-row flex-col-reverse gap-[1%] md:pr-[2%] pr-0">
                                    <div className='max-w-[862px] md:block hidden w-full'>
                                        <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/login/signup.webp' alt="" />
                                    </div>
                                    <div className='max-w-[430px] w-full mt-[4rem] mb-[2rem]'>
                                        <div className="flex items-center gap-2 pt-6 px-2 ">
                                            <AppRegistrationIcon className="text-[#21A6E9]" />
                                            <h6 className=" text-[20px] md:text-[28px] font-[500] font-satoshi text-[#000000]">
                                                Enter Driver / Representative Details
                                            </h6>
                                        </div>

                                        <div className="flex flex-col gap-[1.6vw] md:gap-1 ">

                                            {/* <label htmlFor="" className='mt-[10%] font-[500] font-satoshi text-[13px] text-[#000000] mb-0 pb-[13px]'>Representative Name</label> */}

                                            <label htmlFor="" className='mt-[8%] font-[500] font-satoshi text-[13px] text-[#000000] mb-0 pb-[13px]'
                                                style={{ display: 'inline-block', }}>Representative Name <span style={{ color: 'red', fontWeight: 'bolder', fontSize: "16px", }}>*</span></label>
                                            <div className={`flex items-center gap-[10px] pb-[9px] border-b-[2px] border-solid h-[40px] box-border ${errorInputName === 'driverName' ? 'border-[#FF0000]' : 'border-[#000000]'
                                                }`}>
                                                <img src='https://www.svgrepo.com/show/483503/registration-pictogram-2.svg' alt="" className="w-[20px] h-[20px]" />
                                                <input
                                                    ref={driverNameRef}
                                                    type="text"
                                                    id="driverName"
                                                    name="driverName"
                                                    required
                                                    value={formData.driverName}
                                                    onChange={handleDriverNameChange}
                                                    className="font-[400] outline-none w-full font-satoshi text-[16px] text-[#515151] h-[24px] leading-[24px] p-0 m-0"
                                                    placeholder="Enter Representative Name"
                                                    onKeyDown={(e) => {
                                                        if (e.key === 'Enter') {
                                                            btnSubmitRef.current.click()
                                                            if (modalData.isOpen) {
                                                                closeModal()
                                                            }
                                                        }
                                                    }}
                                                />
                                            </div>

                                            {/* <label htmlFor="" className='mt-[10%] font-[500] font-satoshi text-[13px] text-[#000000] mb-0 pb-[13px]'>Representative Number</label> */}
                                            <label htmlFor="" className='mt-[8%] font-[500] font-satoshi text-[13px] text-[#000000] mb-0 pb-[13px]'
                                                style={{ display: 'inline-block', }}>Representative Number <span style={{ color: 'red', fontWeight: 'bolder', fontSize: "16px", }}>*</span></label>
                                            <div className={`flex items-center gap-[10px] pb-[9px] border-b-[2px] border-solid h-[40px] box-border ${errorInputName === 'driverNumber' ? 'border-[#FF0000]' : 'border-[#000000]'
                                                }`}>
                                                {/* <img src='https://www.svgrepo.com/show/483503/registration-pictogram-2.svg' alt="" className="w-[20px] h-[20px]" /> */}
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-telephone" viewBox="0 0 16 16">
                                                    <path d="M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.6 17.6 0 0 0 4.168 6.608 17.6 17.6 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.68.68 0 0 0-.58-.122l-2.19.547a1.75 1.75 0 0 1-1.657-.459L5.482 8.062a1.75 1.75 0 0 1-.46-1.657l.548-2.19a.68.68 0 0 0-.122-.58zM1.884.511a1.745 1.745 0 0 1 2.612.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.68.68 0 0 0 .178.643l2.457 2.457a.68.68 0 0 0 .644.178l2.189-.547a1.75 1.75 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.6 18.6 0 0 1-7.01-4.42 18.6 18.6 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877z" />
                                                </svg>
                                                <input
                                                    ref={driverNumberRef}
                                                    type="tel"                            // Triggers mobile numeric keypad
                                                    inputMode="numeric"                  // Hint for numeric input
                                                    pattern="[0-9]*"
                                                    id="driverNumber"
                                                    name="driverNumber"
                                                    required
                                                    value={formData.driverNumber}
                                                    onChange={handleDriverMobileChange}
                                                    className="font-[400] outline-none w-full font-satoshi text-[16px] text-[#515151] h-[24px] leading-[24px] p-0 m-0"
                                                    placeholder="Enter Driver Mobile Number"
                                                    onKeyDown={(e) => {
                                                        if (e.key === 'Enter') {
                                                            btnSubmitRef.current.click()
                                                            if (modalData.isOpen) {
                                                                closeModal()
                                                            }
                                                        }
                                                    }}
                                                />
                                            </div>

                                            {/* <label htmlFor="" className='mt-[10%] font-[500] font-satoshi text-[13px] text-[#000000] mb-0 pb-[13px]'>Representative Email</label> */}
                                            <label htmlFor="" className='mt-[8%] font-[500] font-satoshi text-[13px] text-[#000000] mb-0 pb-[13px]'
                                                style={{ display: 'inline-block', }}>Representative Email </label>
                                            <div className={`flex items-center gap-[10px] pb-[9px] border-b-[2px] border-solid h-[40px] box-border ${errorInputName === 'driverEmail' ? 'border-[#FF0000]' : 'border-[#000000]'
                                                }`}>
                                                <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/login/item1.svg' alt="" className="w-[20px] h-[20px]" />
                                                <input
                                                    ref={driverEmailRef}
                                                    type="text"
                                                    id="driverEmail"
                                                    name="driverEmail"
                                                    required
                                                    value={formData.driverEmail}
                                                    onChange={handleDriverEmailChange}
                                                    className="font-[400] outline-none w-full font-satoshi text-[16px] text-[#515151] h-[24px] leading-[24px] p-0 m-0"
                                                    placeholder="Enter Email"
                                                    onKeyDown={(e) => {
                                                        if (e.key === 'Enter') {
                                                            btnSubmitRef.current.click()
                                                            if (modalData.isOpen) {
                                                                closeModal()
                                                            }
                                                        }
                                                    }}
                                                />
                                            </div>

                                            {phoneError && (
                                                <div
                                                    style={{
                                                        color: "red",
                                                        marginTop: "5px",
                                                        marginLeft: "20px",
                                                    }}
                                                >
                                                    {phoneError}
                                                </div>
                                            )}

                                            <div className="flex justify-center fixed bottom-0 left-0 right-0 z-[10] md:relative md:bottom-auto md:left-auto md:right-auto">
                                                <div className="mobile-only-shadow flex items-center justify-between bg-white p-2 rounded-t-xl w-full max-w-[30rem] gap-[0.5rem] mx-auto md:rounded-none md:p-0 md:bg-transparent">
                                                    <button
                                                        onClick={prevStep}
                                                        className="font-satoshi flex items-center justify-center gap-2 text-white text-base font-medium py-3 px-2 rounded-full transition-all w-full
                                                                                     bg-[#EE3840] hover:bg-[#d32f2f]       "
                                                    >
                                                        <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/navbar/right-arrow.svg' alt="Continue" className="h-[1rem] w-[1rem] rotate-180" />
                                                        Back
                                                    </button>
                                                    <button
                                                        ref={btnSubmitRef}
                                                        onClick={handleSubmit}
                                                        className="font-satoshi flex items-center justify-center gap-2 bg-[#21A6E9] hover:bg-[#1e94d6] text-white text-base font-medium py-3 px-1 rounded-full transition-all w-full"
                                                    >
                                                        Continue
                                                        <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/navbar/right-arrow.svg' alt="Back" className="h-[1rem] w-[1rem]" />
                                                    </button>


                                                </div>
                                            </div>

                                        </div></div></div>

                            </div>
                        </>
                    )}
                </div>
            </div >

            <Modal
                isOpen={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                onInsurerChange={handleInsurerChange}
                onSubmit={handleContinue}
                insurerName={matchInsurer(formData.InsuranceName)}
            />
        </>
    )
}

const Modal = ({ isOpen, onClose, onSubmit, insurerName, onInsurerChange }) => {
    // const [selection, setSelection] = useState(null);
    const [selectedInsurer, setSelectedInsurer] = useState("");

    const [selection, setSelection] = useState(true); // default selection is 'Yes'

    useEffect(() => {
        if (isOpen) {
            setSelection(insurerName ? true : false); // dynamic default
            setSelectedInsurer("");
        }
    }, [isOpen, insurerName]);



    // ✅ Listen for Escape key
    useEffect(() => {
        const handleKeyDown = (e) => {
            if (e.key === "Escape") {
                onClose();
            }
        };

        if (isOpen) {
            window.addEventListener("keydown", handleKeyDown);
        }

        return () => {
            window.removeEventListener("keydown", handleKeyDown);
        };
    }, [isOpen, onClose]);

    const isContinueDisabled = () => {
        if (selection === null) return true;
        if (
            selection === false &&
            (!selectedInsurer || selectedInsurer === "Select Insurer")
        )
            return true;
        return false;
    };

    const handleRadioChange = (value) => {
        setSelection(value);
    };

    const handleInsurerChange = (e) => {
        const value = e.target.value;
        setSelectedInsurer(value);
        onInsurerChange(value);
    };

    const modalRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (modalRef.current && !modalRef.current.contains(event.target)) {
                onClose();
            }
        };

        if (isOpen) {
            document.addEventListener("mousedown", handleClickOutside);
        }

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [isOpen,]);

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[1000] px-4">
            <div ref={modalRef} className="bg-white rounded-[24px] shadow-xl w-full max-w-[520px] p-6 md:p-8 relative animate-fadeIn">
                <h6 className="text-center text-[22px] md:text-[26px] font-semibold text-gray-800 mb-6 font-satoshi">
                    {selection === false
                        ? "Please select your Insurer"
                        : "Please verify your Insurer"}
                </h6>

                <div className="mb-6">
                    <label className="flex items-center gap-2 text-gray-800 font-satoshi font-medium text-[16px] mb-2">
                        <span className="flex items-center gap-2 mt-2">
                            <ShieldCheck size={18} />
                            Insurer Name
                        </span>
                    </label>

                    {selection === false ? (
                        <InsurerSelect
                            value={selectedInsurer}
                            onChange={handleInsurerChange}
                        />
                    ) : (
                        <input
                            type="text"
                            name="vehicleNo"
                            value={insurerName}
                            readOnly
                            placeholder="Enter Insurer Name"
                            maxLength={30}
                            className="w-full h-[55px] bg-gray-100 border border-gray-300 text-gray-700 text-base rounded-lg px-4 focus:outline-none focus:ring-2 focus:ring-[#21A6E9] transition"
                        />
                    )}
                </div>

                <div className="flex gap-3 mb-3">
                    <label className="flex font-satoshi items-center gap-3 cursor-pointer text-gray-700 text-[16px] font-medium">
                        <input
                            type="radio"
                            className="w-5 h-5 accent-[#21A6E9] focus:ring-2 focus:ring-[#21A6E9] cursor-pointer"
                            name="insurerCheck"
                            checked={selection === true}
                            onChange={() => handleRadioChange(true)}
                        />
                        Yes
                    </label>
                    <label className="flex font-satoshi items-center gap-3 cursor-pointer text-gray-700 text-[16px] font-medium">
                        <input
                            type="radio"
                            className="w-5 h-5 accent-[#21A6E9] focus:ring-2 focus:ring-[#21A6E9] cursor-pointer"
                            name="insurerCheck"
                            checked={selection === false}
                            onChange={() => handleRadioChange(false)}
                        />
                        No
                    </label>
                </div>

                <div className="flex justify-between gap-4">
                    <button
                        onClick={onClose}
                        className=" font-satoshi flex items-center justify-center gap-2 bg-[#EE3840] hover:bg-[#d32f2f] text-white text-base font-sm py-3 px-6 rounded-full transition-all w-full"
                    >
                        <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/navbar/right-arrow.svg' alt="Back" className="h-[1rem] w-[1rem] rotate-180" />
                        Back
                    </button>

                    <button
                        onClick={() => onSubmit(insurerName)}
                        disabled={isContinueDisabled()}
                        className={`font-satoshi flex items-center justify-center gap-2 text-white text-base font-sm py-3 px-6 rounded-full transition-all w-full ${isContinueDisabled()
                            ? "bg-[#a7dbf5] cursor-not-allowed"
                            : "bg-[#21A6E9] hover:bg-[#1e94d6]"
                            }`}
                    >
                        Continue
                        <img
                            src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/navbar/right-arrow.svg'
                            alt="Continue"
                            className="h-[1rem] w-[1rem]"
                        />
                    </button>
                </div>
            </div>
        </div>
    );
};



